// import React, { Component } from "react";
import salesman from "salesman.js";
//import Places, { calculateDistance } from "../Models/Places";
import { getDistance, getPreciseDistance } from "geolib";
import { DateTime } from "luxon";
import { LIMIT_MESSAGES } from "./GateLimit";
import { countries as COUNTRY_LIST } from "../Data/Countries";
import poi from "../assets/images/poi.png";
import airport from "../assets/icons/airport.png";
import arbol from "../assets/icons/arbol.png";
import arch from "../assets/icons/arch.png";
import art_museum_2 from "../assets/icons/art-museum-2.png";
import atm_2 from "../assets/icons/atm-2.png";
import bags from "../assets/icons/bags.png";
import bank from "../assets/icons/bank.png";
import bar from "../assets/icons/bar.png";
import barber from "../assets/icons/barber.png";
import bar_coktail from "../assets/icons/bar_coktail.png";
import beach from "../assets/icons/beach.png";
import beautifulview from "../assets/icons/beautifulview.png";
import bed_breakfast1_2 from "../assets/icons/bed_breakfast1-2.png";
import bicycle_shop from "../assets/icons/bicycle_shop.png";
import bigcity from "../assets/icons/bigcity.png";
import binoculars from "../assets/icons/binoculars.png";
import boat from "../assets/icons/boat.png";
import bus from "../assets/icons/bus.png";
import bustour from "../assets/icons/bustour.png";
import cablecar from "../assets/icons/cablecar.png";
import campingcar from "../assets/icons/campingcar.png";
import car from "../assets/icons/car.png";
import carrental from "../assets/icons/carrental.png";
import castle_2 from "../assets/icons/castle-2.png";
import cathedral from "../assets/icons/cathedral.png";
import caution from "../assets/icons/caution.png";
import cave_2 from "../assets/icons/cave-2.png";
import cemetary from "../assets/icons/cemetary.png";
import church_2 from "../assets/icons/church-2.png";
import citysquare from "../assets/icons/citysquare.png";
import climbing_bentgate_carabiner from "../assets/icons/climbing-bentgate_carabiner.png";
import coffee from "../assets/icons/coffee.png";
import congress from "../assets/icons/congress.png";
import conveniencestore from "../assets/icons/conveniencestore.png";
import cruiseship from "../assets/icons/cruiseship.png";
import currencyexchange from "../assets/icons/currencyexchange.png";
import dentist from "../assets/icons/dentist.png";
import departmentstore from "../assets/icons/departmentstore.png";
import desert_2 from "../assets/icons/desert-2.png";
import doctor from "../assets/icons/doctor.png";
import dogs_leash from "../assets/icons/dogs_leash.png";
import family from "../assets/icons/family.png";
import firstaid from "../assets/icons/firstaid.png";
import home_2 from "../assets/icons/home-2.png";
import hospital_building from "../assets/icons/hospital-building.png";
import hospital from "../assets/icons/hospital.png";
import japanese_food from "../assets/icons/japanese-food.png";
import kayaking from "../assets/icons/kayaking.png";
import lake from "../assets/icons/lake.png";
import laundromat from "../assets/icons/laundromat.png";
import letter_a from "../assets/icons/letter_a.png";
import letter_b from "../assets/icons/letter_b.png";
import letter_c from "../assets/icons/letter_c.png";
import letter_d from "../assets/icons/letter_d.png";
import letter_e from "../assets/icons/letter_e.png";
import letter_f from "../assets/icons/letter_f.png";
import letter_g from "../assets/icons/letter_g.png";
import letter_h from "../assets/icons/letter_h.png";
import letter_i from "../assets/icons/letter_i.png";
import letter_j from "../assets/icons/letter_j.png";
import letter_k from "../assets/icons/letter_k.png";
import letter_l from "../assets/icons/letter_l.png";
import letter_m from "../assets/icons/letter_m.png";
import letter_n from "../assets/icons/letter_n.png";
import letter_o from "../assets/icons/letter_o.png";
import letter_p from "../assets/icons/letter_p.png";
import letter_q from "../assets/icons/letter_q.png";
import letter_r from "../assets/icons/letter_r.png";
import letter_s from "../assets/icons/letter_s.png";
import letter_t from "../assets/icons/letter_t.png";
import letter_u from "../assets/icons/letter_u.png";
import letter_v from "../assets/icons/letter_v.png";
import letter_w from "../assets/icons/letter_w.png";
import letter_x from "../assets/icons/letter_x.png";
import letter_y from "../assets/icons/letter_y.png";
import letter_z from "../assets/icons/letter_z.png";
import library from "../assets/icons/library.png";
import lighthouse_2 from "../assets/icons/lighthouse-2.png";
import lodging_2 from "../assets/icons/lodging-2.png";
import mall from "../assets/icons/mall.png";
import marina_2 from "../assets/icons/marina-2.png";
import medicine from "../assets/icons/medicine.png";
import memorial from "../assets/icons/memorial.png";
import monument from "../assets/icons/monument.png";
import mosquee from "../assets/icons/mosquee.png";
import mountains from "../assets/icons/mountains.png";
import museum_archeological from "../assets/icons/museum_archeological.png";
import museum_art from "../assets/icons/museum_art.png";
import museum_crafts from "../assets/icons/museum_crafts.png";
import museum_industry from "../assets/icons/museum_industry.png";
import museum_naval from "../assets/icons/museum_naval.png";
import museum_war from "../assets/icons/museum_war.png";
import number_0 from "../assets/icons/number_0.png";
import number_1 from "../assets/icons/number_1.png";
import number_2 from "../assets/icons/number_2.png";
import number_3 from "../assets/icons/number_3.png";
import number_4 from "../assets/icons/number_4.png";
import number_5 from "../assets/icons/number_5.png";
import number_6 from "../assets/icons/number_6.png";
import number_7 from "../assets/icons/number_7.png";
import number_8 from "../assets/icons/number_8.png";
import number_9 from "../assets/icons/number_9.png";
import parkinggarage from "../assets/icons/parkinggarage.png";
import pets from "../assets/icons/pets.png";
import playground from "../assets/icons/playground.png";
import recycle from "../assets/icons/recycle.png";
import regroup from "../assets/icons/regroup.png";
import repair from "../assets/icons/repair.png";
import resort from "../assets/icons/resort.png";
import restaurant_chinese from "../assets/icons/restaurant_chinese.png";
import restaurant_fish from "../assets/icons/restaurant_fish.png";
import restaurant_greek from "../assets/icons/restaurant_greek.png";
import restaurant_indian from "../assets/icons/restaurant_indian.png";
import restaurant_italian from "../assets/icons/restaurant_italian.png";
import restaurant_korean from "../assets/icons/restaurant_korean.png";
import restaurant_mediterranean from "../assets/icons/restaurant_mediterranean.png";
import restaurant_mexican from "../assets/icons/restaurant_mexican.png";
import restaurant_thai from "../assets/icons/restaurant_thai.png";
import restaurant_vegetarian from "../assets/icons/restaurant_vegetarian.png";
import river_2 from "../assets/icons/river-2.png";
import road from "../assets/icons/road.png";
import sandwich_2 from "../assets/icons/sandwich-2.png";
import school from "../assets/icons/school.png";
import skiing from "../assets/icons/skiing.png";
import stadium from "../assets/icons/stadium.png";
import supermarket from "../assets/icons/supermarket.png";
import taxi from "../assets/icons/taxi.png";
import temple_2 from "../assets/icons/temple-2.png";
import toilets_inclusive from "../assets/icons/toilets_inclusive.png";
import town from "../assets/icons/townhouse.png";
import train from "../assets/icons/train.png";
import tramway from "../assets/icons/tramway.png";
import tree from "../assets/icons/tree.png";
import veterinary from "../assets/icons/veterinary.png";
import villa from "../assets/icons/villa.png";
import walkingtour from "../assets/icons/walkingtour.png";
import winebar from "../assets/icons/winebar.png";
import zoo from "../assets/icons/zoo.png";
import restaurant from "../assets/icons/restaurant.png";
import hotel from "../assets/icons/hotel.png";
import theater from "../assets/icons/theater.png";
import bridge_modern from "../assets/icons/bridge_modern.png";
import icecream from "../assets/icons/icecream.png";
import soccer from "../assets/icons/soccer.png";
import golf_2 from "../assets/icons/golf-2.png";
import area from "../assets/icons/area.png";
import excursion from "../assets/icons/excursion.png";
import fast_food from "../assets/icons/fast_food.png";
import kids from "../assets/icons/kids.png";
import leisure from "../assets/icons/leisure.png";
import nearby from "../assets/icons/nearby.png";
import neighborhood from "../assets/icons/neighborhood.png";
import nightlife from "../assets/icons/nightlife.png";
import outdoors from "../assets/icons/outdoors.png";
import restaurant_french from "../assets/icons/restaurant_french.png";
import restaurant_japanese from "../assets/icons/restaurant_japanese.png";
import restaurant_pizza from "../assets/icons/restaurant_pizza.png";
import restaurant_vegan from "../assets/icons/restaurant_vegan.png";
import shopping from "../assets/icons/shopping.png";
import sports from "../assets/icons/sports.png";
import tour from "../assets/icons/tour.png";
import trail from "../assets/icons/trail.png";
import trip from "../assets/icons/trip.png";
import country from "../assets/icons/country.png";
import search from "../assets/icons/search.png";
import bakery from "../assets/icons/bakery.png";
import restaurant_steakhouse from "../assets/icons/restaurant_steakhouse.png";
import restaurant_venezuela from "../assets/icons/restaurant_venezuela.png";

import color_green from "../assets/icons/color_green.png";
import color_teal from "../assets/icons/color_teal.png";
import color_blue from "../assets/icons/color_blue.png";
import color_purple from "../assets/icons/color_purple.png";
import color_brown from "../assets/icons/color_brown.png";
import color_red from "../assets/icons/color_red.png";
import color_orange from "../assets/icons/color_orange.png";
import color_light_green from "../assets/icons/color_light_green.png";

import google_places_logo from "../assets/images/google-places-logo.jpg";
import place_png from "../assets/images/place.png";
import bear from "../assets/icons/bear.png";
import bridge_old from "../assets/icons/bridge_old.png";
import canyon_2 from "../assets/icons/canyon-2.png";
import cinema from "../assets/icons/cinema.png";
import dancinghall from "../assets/icons/dancinghall.png";
import deer from "../assets/icons/deer.png";
import fishing from "../assets/icons/fishing.png";
import geyser_2 from "../assets/icons/geyser-2.png";
import glacier_2 from "../assets/icons/glacier-2.png";
import historical_museum from "../assets/icons/historical_museum.png";
import hotspring from "../assets/icons/hotspring.png";
import moose from "../assets/icons/moose.png";
import museum_science from "../assets/icons/museum_science.png";
import music_classical from "../assets/icons/music_classical.png";
import palace_2 from "../assets/icons/palace-2.png";
import panoramicview from "../assets/icons/panoramicview.png";
import ruins_2 from "../assets/icons/ruins-2.png";
import sight_2 from "../assets/icons/sight-2.png";
import smallcity from "../assets/icons/smallcity.png";
import state from "../assets/icons/state.png";
import statue_2 from "../assets/icons/statue-2.png";
import synagogue_2 from "../assets/icons/synagogue-2.png";
import volcano_2 from "../assets/icons/volcano-2.png";
import waterfall_2 from "../assets/icons/waterfall-2.png";
import wetlands from "../assets/icons/wetlands.png";
import world from "../assets/icons/world.png";
import star_3 from "../assets/icons/star-3.png";
import island_icon from "../assets/icons/Island_icon.png";
import building from "../assets/icons/building.png";
import casino_2 from "../assets/icons/casino-2.png";
import photo from "../assets/icons/photo.png";
import audio from "../assets/icons/audio.png";
import video from "../assets/icons/video.png";
import information from "../assets/icons/information.png";
import garden from "../assets/icons/garden.png";
import forest from "../assets/icons/forest2.png";
import aquarium from "../assets/icons/aquarium.png";
import themepark from "../assets/icons/themepark.png";
import climbing from "../assets/icons/climbing.png";
import horse from "../assets/icons/horseriding.png";
import surfing from "../assets/icons/surfing.png";
import farm from "../assets/icons/farm-2.png";
import factory from "../assets/icons/factory.png";
import science from "../assets/icons/museum_science.png";
import art from "../assets/icons/artgallery.png";
import observatory from "../assets/icons/observatory.png";
import brewery from "../assets/icons/brewery1.png";

// Rough visit-length estimates (minutes) by Google Places "type" string, for
// places pulled from the Places API — which has no duration field of its
// own. Not exhaustive; anything not listed falls back to the same 30-minute
// default Place.js's constructor already uses. Deliberately coarse (a
// museum could be 45 minutes or 3 hours depending on the person) — this is
// a starting estimate for automatic scheduling, not a precise prediction,
// same spirit as Cities.js's popularity scores.
const PLACE_TYPE_DURATIONS = {
  amusement_park: 240,
  aquarium: 90,
  // art_gallery/museum/historical_landmark/tourist_attraction raised
  // 2026-09-07 — real trip feedback that schedules built from these felt
  // "too busy": these four cover most walkable sightseeing stops, so a
  // systematically-short estimate on them understaffs nearly every day.
  art_gallery: 120,
  museum: 150,
  zoo: 150,
  national_park: 180,
  hiking_area: 150,
  park: 60,
  beach: 120,
  botanical_garden: 75,
  historical_landmark: 45,
  monument: 20,
  church: 30,
  hindu_temple: 30,
  mosque: 30,
  synagogue: 30,
  place_of_worship: 30,
  tourist_attraction: 75,
  observation_deck: 45,
  casino: 90,
  night_club: 120,
  spa: 90,
  stadium: 120,
  shopping_mall: 90,
  market: 60,
  restaurant: 75,
  cafe: 45,
  bar: 75,
  bakery: 20,
  zoo_wildlife_park: 150,
};

// A handful of world-famous mega-attractions Google (and our own Featured
// Guides manifest, which only ever resolves to a single generic category
// name) routinely tag with nothing more specific than "tourist_attraction"
// — Galleria dell'Accademia came back with no "museum"/"art_gallery" type
// at all, verified live 2026-09-07 — landing them in the same duration
// bucket as a quick photo stop instead of the multi-hour visit they
// actually take. Matched by case-insensitive name substring since Google's
// `types` field can't be trusted to carry the "this one is huge" signal
// these sites share. Deliberately a short, curated list of unmistakably
// famous sites, not a general "big museum" detector — a false positive
// here just makes one stop's estimate generous, but the list shouldn't grow
// to the point where it starts mislabeling ordinary same-named places.
const MEGA_ATTRACTION_DURATION_MINUTES = 180;
const MEGA_ATTRACTION_NAME_KEYWORDS = [
  "uffizi",
  // Not bare "accademia" — that also matched "Accademia di Belle Arti di
  // Firenze", an unrelated art school confirmed 2026-09-07 to genuinely
  // need only ~1-1.5 hours, not the multi-hour floor this list applies.
  // "galleria dell'accademia" targets only the actual David/tourist-
  // attraction gallery this list is meant for.
  "galleria dell'accademia",
  "louvre",
  "vatican museum",
  "sistine chapel",
  "british museum",
  "hermitage museum",
  "prado museum",
  "metropolitan museum of art",
  "museum of modern art",
  "moma",
  "smithsonian",
  "rijksmuseum",
  "van gogh museum",
  "guggenheim",
  "musée d'orsay",
  "musee d'orsay",
];

// Multiplies each place's estimated Duration before it's placed on a
// schedule. Doesn't change the day count — it changes how many events fit
// into the days already requested (fewer, longer stops at Relaxed; more,
// shorter stops at Packed). Shared here (rather than duplicated per screen)
// after a real gap: BuildMyTripWizard.js/BuildScheduleDialog.js each had
// their own copy of this list, but DestinationsScreen.js's own "Auto-
// Build"/"Let Me Pick" offer routes straight into BuildMyTripWizard's
// autoStart path — skipping its setup screen (and the Pace picker on it)
// entirely — so that offer needs its own Pace choice too. One shared list
// means a future picker doesn't have to remember to duplicate it again.
// Default is Relaxed (1.3), not Normal (1) — real trip feedback that
// auto-built schedules felt "too busy" by default. Kept in sync with
// andiamo-places' identical Common.PACE_OPTIONS.
const PACE_OPTIONS = [
  { value: "1.6", label: "Very relaxed — long stops, lots of downtime" },
  { value: "1.3", label: "Relaxed — fewer stops, more time at each" },
  { value: "1", label: "Normal" },
  { value: "0.75", label: "Packed — see as much as possible" },
];

export default class Common {
  static PACE_OPTIONS = PACE_OPTIONS;
  // constructor(props) {
  //   super(props);
  // }
  init() {
    window.directions_shape = null;
    window.app_images = "../../common/app_files/img/";
    window.places_viewModel = new Array();
    window.map = null;
    window.searchMarkerLoc = null;
    window.webSite = "http://liquidguides.com/";
    window.ImageLoc = "/Media/Photos/";
    window.maploaded = false;
    window.MapCommand = "init";
    window.map_initialized = false;
    window.ImageSize = "M";
    window.bing_init = false;
    window.gmap3_init = false;
  }

  // Single source of truth for the "expiring soon" rule used by
  // TravelersDialog, TravelerDocumentsDialog, and the guide-level expiry
  // banner — a 6-month-from-today window (not trip-specific dates, since
  // guide date ranges live on schedule events, not GuideAttributes).
  static DOCUMENT_EXPIRY_WARNING_MONTHS = 6;

  static getDocumentExpiryStatus = (expiryDateStr) => {
    if (!expiryDateStr) return "ok";
    const expiry = new Date(expiryDateStr + "T00:00:00");
    if (isNaN(expiry.getTime())) return "ok";
    const today = new Date();
    today.setHours(0, 0, 0, 0);
    if (expiry < today) return "expired";
    const warnDate = new Date(today);
    warnDate.setMonth(warnDate.getMonth() + Common.DOCUMENT_EXPIRY_WARNING_MONTHS);
    if (expiry <= warnDate) return "soon";
    return "ok";
  };

  static isMirror = (arr1, arr2) => {
    const alength = arr1.length;
    if (alength !== arr2.length) return false;
    for (let i = 0; i < alength; i++) {
      if (arr1[i] !== arr2[alength - 1 - i]) return false;
    }

    // Given array is mirror-inverse
    return true;
  };

  static shortenText = (_text, textLength) => {
    let text = _text;
    if (text == null) return "";
    if (text.length > textLength) {
      text = text.substring(0, textLength) + "...";
    }
    return text;
  };

  static permute(permutation) {
    var length = permutation.length,
      result = [permutation.slice()],
      c = new Array(length).fill(0),
      i = 1,
      k,
      p;

    while (i < length) {
      if (c[i] < i) {
        k = i % 2 && c[i];
        p = permutation[i];
        permutation[i] = permutation[k];
        permutation[k] = p;
        ++c[i];
        i = 1;
        result.push(permutation.slice());
      } else {
        c[i] = 0;
        ++i;
      }
    }
    return result;
  }

  static calculateDistance(p1, p2) {
    //console.log("calculateDistance", p1, p2);
    if (p1 == null || p2 == null) return 0;
    if (p1.latitude == null || p2.latitude == null) return 0;
    var dis = getDistance(
      { latitude: parseFloat(p1.latitude), longitude: parseFloat(p1.longitude) },
      { latitude: parseFloat(p2.latitude), longitude: parseFloat(p2.longitude) }
    );

    //console.log(p1, p2, dis);
    if (dis === undefined || typeof dis !== "number" || isNaN(dis)) return 0;

    //console.log("calculateDistance", dis / 1000);
    return dis / 1000;
  }

  // Meters between two lat/long points — same signature as the
  // now-removed per-file _haversineMeters helpers in PlacesHeader.js and
  // HomeHeader.js, shared here so photo-proximity matching/clustering logic
  // in both files stays consistent.
  // Imported guides carry an external climate page (e.g. weatherspark) in a
  // "urllink:" button. Those are opened in the app's own Climate dialog
  // instead, which needs a location: the guide's own location
  // (attributes.base_location + its first city/country), else its first place with valid
  // coordinates (same choice the generated "climatelink" makes). null if none.
  static isExternalClimateUrl(url) {
    return /^https?:\/*(www\.)?weatherspark\.com/i.test(url || "");
  }

  // "…/y/51381/Average-Weather-in-Amsterdam-Netherlands-Year-Round" ->
  // { city: "Amsterdam", country: "Netherlands" }. The country is the longest
  // trailing run of words that is a known country name ("New-Zealand",
  // "United-States"); the rest is the city. No coordinates here — the Climate
  // dialog geocodes city/country itself. null if the slug doesn't match.
  static parseClimateUrlLocation(url) {
    let slug = "";
    try { slug = decodeURIComponent(String(url || "").split(/[?#]/)[0].split("/").filter(Boolean).pop() || ""); } catch (e) { return null; }
    const m = slug.match(/^Average-Weather-in-(.+?)(?:-Year-Round)?$/i);
    if (!m) return null;
    const words = m[1].split("-").filter(Boolean);
    const known = new Map(COUNTRY_LIST.map((c) => [c.toLowerCase(), c]));
    for (let k = Math.min(4, words.length - 1); k >= 1; k--) {
      const country = known.get(words.slice(-k).join(" ").toLowerCase());
      if (country) return { city: words.slice(0, -k).join(" "), country };
    }
    return { city: words.join(" "), country: "" };
  }

  static guideClimateLocation() {
    const g = window.guide_obj;
    const bl = g?.attributes?.base_location;
    const lat = parseFloat(bl?.latitude);
    const lon = parseFloat(bl?.longitude);
    if (!isNaN(lat) && !isNaN(lon) && !(lat === 0 && lon === 0)) {
      return { city: g.attributes.cities?.[0] || "", country: g.attributes.countries?.[0] || "", lat, lon };
    }
    const list = g?.places?.placesList || [];
    const p = list.find(
      (x) => x && typeof x.Lat === "number" && typeof x.Longi === "number" && !isNaN(x.Lat) && !isNaN(x.Longi) && !(x.Lat === 0 && x.Longi === 0)
    );
    return p ? { city: p.City, country: p.Country, lat: p.Lat, lon: p.Longi } : null;
  }

  // The itinerary/home-page cover image. If it fails to load (expired link,
  // deleted file), window.coverImageFailed (Home.js) hides the broken image
  // and — for people who can edit — reveals the hidden tile below it. Viewers
  // see neither, so a shared guide doesn't show a hole they can't fix. `url`
  // must already be a displayable URL.
  static coverImageHTML(url) {
    return (
      `<p style="text-align:center;">` +
      `<img src="${url}" alt="Image" referrerpolicy="no-referrer" style="width:100%; max-width:700px; height:auto; border-radius:10%" onerror="window.coverImageFailed&&window.coverImageFailed(this)"></img>` +
      // A span (not the link itself) is hidden/shown: the itinerary iframe's
      // stylesheet forces any <a> with an inline "background" to display as a
      // pill, which would override display:none.
      //
      // Plain text, not a clickable "editcoverlink:" link — that link relied
      // on this content's iframe-to-parent customLink bridge, which turned
      // out unreliable depending on how/where this HTML gets displayed
      // (some display paths never wire it up), silently promising an action
      // that didn't fire. Point at the real, always-available manual path
      // instead. Found 2026-09-27.
      `<span data-cover-fix="1" style="display:none; max-width:700px; margin:0 auto; padding:28px 16px; border:1.5px dashed #BFDBFE; border-radius:10px; background:#F5F9FF; text-align:center;">` +
      `<span style="color:#2F6FE5; font-size:14px;">Cover image failed to load. Update it via Edit &rarr; Edit Guide Info.</span>` +
      `</span>` +
      `</p>`
    );
  }

  // The itinerary page stores its cover image's address inside its HTML, so
  // changing the guide's image (e.g. via the "Cover image unavailable" tile)
  // wouldn't update the page. Swaps the src of the cover <img> (the one that
  // carries the coverImageFailed handler, see coverImageHTML) and leaves
  // everything else alone. Returns html unchanged if there is no such image.
  static replaceCoverImageURL(html, url) {
    if (!html || !url) return html;
    const safe = String(url).replace(/"/g, "%22");
    const re = /(<img\b[^>]*?\bsrc=")[^"]*("[^>]*coverImageFailed)/;
    return re.test(html) ? html.replace(re, (m, a, b) => a + safe + b) : html;
  }

  static haversineMeters(lat1, lon1, lat2, lon2) {
    if (lat1 == null || lon1 == null || lat2 == null || lon2 == null) return Infinity;
    const dis = getDistance(
      { latitude: parseFloat(lat1), longitude: parseFloat(lon1) },
      { latitude: parseFloat(lat2), longitude: parseFloat(lon2) }
    );
    if (dis === undefined || typeof dis !== "number" || isNaN(dis)) return Infinity;
    return dis;
  }

  // Distance-based travel-time estimate between two places — was duplicated
  // verbatim across 7 call sites in Schedule.js, TripAI.js, PlacesHeader.js,
  // BuildMyTripWizard.js, and KMLInput.js; consolidated here rather than
  // patching some copies and not others. Assumes walking pace for short
  // hops, switches to a faster-transport pace beyond ~45 minutes of
  // walking, then applies a flat safety margin on top — a pure
  // speed/distance estimate consistently runs optimistic in practice
  // (waiting for transit, wrong turns, traffic), so it's safer to leave a
  // schedule with a little slack than one that's realistically infeasible.
  // Uses haversineMeters (not Places.calculateDistance, which is the same
  // geolib math but would require Common.js to import Places.js — which
  // already imports Common.js, a circular dependency) — /1000 for km to
  // match the original formula's units.
  // `roundingTo` matches every original call site's own parameter: 0 means
  // "treat as zero travel time" (a few callers pass this deliberately),
  // any other value (including undefined/omitted) just means "give me a
  // real estimate."
  //
  // Distance-band table instead of a flat 2-tier formula — a straight-line
  // proxy, not real routing, but it distinguishes "next door" from "across
  // town" instead of collapsing both into the same number. The old formula
  // rounded every nonzero result UP to at least one full `roundingTo` unit
  // (typically the user's 30-minute event-time-rounding preference), so a
  // place literally next door got the same 30 minutes as one 25 minutes
  // away. Rounded to the nearest 5 minutes here instead, deliberately
  // decoupled from event-time rounding (that setting is about event start
  // times landing on nice clock times, not about travel-time precision) —
  // found 2026-08-31 after a user noticed featured-guide-sourced schedules
  // all had identical 30-minute gaps regardless of actual distance.
  static estimateTravelTimeMinutes(place1, place2, roundingTo) {
    if (!place1 || !place2) return 0;
    if (roundingTo === 0) return 0;
    const distanceKm = (Common.haversineMeters(place1.Lat, place1.Longi, place2.Lat, place2.Longi) / 1000) * 1.2;
    // Previously this function only ever modeled driving, extrapolating the
    // ~35km/h city/highway blend forever past 15km with no idea trains or
    // planes exist — a Rome->Florence (279km, really a ~3.5hr train) or
    // Paris->Rome (1330km, really a ~3.4hr flight) leg came out as 30+ hours
    // of "driving", which is what actually builds every schedule's timing
    // (recalculateSchedule, ScheduleBuilder.js, TripAI's addEventOptimized,
    // KMLInput.js, etc). estimateTravel (below) already had train/plane
    // bands for its own display purposes, but they were never applied here
    // — so the number shown next to a schedule row and the number that
    // actually built the schedule's timing could silently disagree. Folded
    // in here 2026-09-23 so every caller gets mode-aware timing for free.
    if (distanceKm <= 200) {
      const TRAVEL_TIME_BANDS = [
        { maxKm: 0.2, minutes: 3 },   // same block/plaza
        { maxKm: 0.5, minutes: 8 },   // short walk
        { maxKm: 1, minutes: 15 },    // longer walk
        { maxKm: 2, minutes: 20 },    // brisk walk or quick transit/taxi hop
        { maxKm: 4, minutes: 30 },    // short drive/transit ride
        { maxKm: 8, minutes: 40 },    // medium drive
        { maxKm: 15, minutes: 55 },   // longer drive across a city
      ];
      const band = TRAVEL_TIME_BANDS.find((b) => distanceKm <= b.maxKm);
      // Beyond the table: continue from the last band's value at ~35 km/h
      // (a city/highway driving-speed blend), not restart from zero.
      const travel_time = band ? band.minutes : 55 + (distanceKm - 15) * 1.7;
      return Math.max(0, Math.round(travel_time / 5) * 5);
    }
    if (distanceKm <= 800) {
      // Rough effective rail speed (accounting for stations/stops, not pure
      // high-speed-rail everywhere) — the car extrapolation above would show
      // an absurd number of hours at this range.
      return Math.max(0, Math.round(((distanceKm / 80) * 60) / 5) * 5);
    }
    // Cruise speed plus a fixed airport/security/boarding overhead — still a
    // rough estimate (no real flight-route data), but the right order of
    // magnitude, unlike the car/train formulas would give here.
    return Math.max(0, Math.round((90 + (distanceKm / 700) * 60) / 5) * 5);
  }

  // Schedule display's "travel row" between two consecutive event cards
  // (SchedulePanel.js) — mode/icon guessed from distance alone (no real mode
  // is stored anywhere), minutes deferred entirely to estimateTravelTimeMinutes
  // so the displayed gap always matches what actually built the schedule
  // (that function owns all the distance-band math now, this just labels it).
  // Bus deliberately has no band of its own — it overlaps car's and train's
  // distance ranges too much for a distance-only guess to claim it
  // specifically; showing "car" for a bus trip is a smaller, more honest
  // miss than showing a wrong specific mode. v1 (see conversation): not
  // user-editable — the time is just the two events' actual Start/End gap,
  // already edited by moving/resizing an event; a per-leg mode override may
  // follow as a fast-follow once a real guide shows the guess visibly wrong.
  static estimateTravel(place1, place2) {
    if (!place1 || !place2) return null;
    const distanceKm = (Common.haversineMeters(place1.Lat, place1.Longi, place2.Lat, place2.Longi) / 1000) * 1.2;
    const mode = distanceKm <= 2 ? "walk" : distanceKm <= 200 ? "car" : distanceKm <= 800 ? "train" : "plane";
    const icon = mode === "walk" ? "person-walking" : mode;
    const minutes = Common.estimateTravelTimeMinutes(place1, place2, 5);
    const distanceLabel = distanceKm < 1 ? `${Math.round(distanceKm * 1000)} m` : `${distanceKm.toFixed(distanceKm < 10 ? 1 : 0)} km`;
    return { mode, icon, distanceKm, minutes, distanceLabel };
  }

  // "45 min away" vs "1.5 hours away" — estimateTravelTimeMinutes' own
  // >55-minute extrapolation means candidate lists (schedule swap/replace
  // pickers) can show quite large minute counts; past an hour, minutes
  // stop reading as an at-a-glance quantity the way a decimal hour count
  // does. Rounded to 1 decimal place, not the nearest 5/10/30 minutes,
  // since this is already a rounded estimate.
  static formatTravelAway(minutes) {
    if (minutes == null) return "";
    if (minutes >= 60) {
      const hours = Math.round((minutes / 60) * 10) / 10;
      return `${hours} hour${hours === 1 ? "" : "s"} away`;
    }
    return `${minutes} min away`;
  }

  // Same minutes-vs-hours breakpoint as formatTravelAway, without the
  // "away" suffix — for the schedule travel row (estimateTravel above),
  // where the number sits next to a distance instead of standing alone.
  static formatTravelDuration(minutes) {
    if (minutes == null) return "";
    if (minutes >= 60) {
      const hours = Math.round((minutes / 60) * 10) / 10;
      return `${hours} hr${hours === 1 ? "" : "s"}`;
    }
    return `${minutes} min`;
  }

  // Rounds a Luxon DateTime UP to the next incrementMinutes (e.g. 15), so
  // auto-built schedule events land on clean clock times (e.g. 12:15-13:15)
  // instead of the leftover fractional-minute drift (12:14-13:12) that
  // comes from accumulating travel-time/duration minutes onto a running
  // clock with no rounding step. Rounds up rather than to nearest
  // deliberately: opening-hours/conflict checks run against the unrounded
  // time before this is called, so rounding could only move a time earlier
  // if it rounded down — reintroducing a conflict that was already cleared,
  // or overlapping the previous event. Rounding up can only push a time
  // later than what was already validated. incrementMinutes <= 0 (or
  // missing) leaves dt untouched, matching event_time_rounding's existing
  // "0 = off" convention in estimateTravelTimeMinutes above.
  static roundDateTimeToNearestMinutes(dt, incrementMinutes) {
    if (!incrementMinutes || incrementMinutes <= 0) return dt;
    const totalMinutes = dt.hour * 60 + dt.minute + dt.second / 60;
    const rounded = Math.ceil(totalMinutes / incrementMinutes) * incrementMinutes;
    return dt.startOf("day").plus({ minutes: rounded });
  }

  // Greedy nearest-neighbor tour over {lat, lon, ...} entries — good enough
  // for TripAI's "Explore Destinations" input size (a handful of cities
  // across 1-3 countries), not a real TSP solver. Returns a new array; does
  // not mutate the input.
  //
  // `options.fixedStart`/`options.fixedEnd` (optional, reference-equal to an
  // entry already in `cities`) pin that city to the front/back of the
  // returned route — e.g. a flight's arrival/departure city, which the user
  // doesn't get to choose freely and may not even be the most "popular" city
  // in its country. Without these, the route just starts at `cities[0]`
  // (same as before this option existed).
  static orderCitiesByNearestNeighbor(cities, options = {}) {
    if (!Array.isArray(cities) || cities.length <= 1) return cities ? cities.slice() : [];
    const { fixedStart, fixedEnd } = options;
    // Pull the pinned endpoints out of the pool the greedy walk operates
    // over, so they can't get visited early — fixedEnd in particular must
    // stay unvisited until everything else has been placed.
    const pool = cities.filter((c) => c !== fixedStart && c !== fixedEnd);
    const first = fixedStart || pool.shift() || fixedEnd;
    if (!first) return [];
    const remaining = pool;
    const ordered = [first];
    let current = first;
    while (remaining.length > 0) {
      let nearestIdx = 0;
      let nearestDist = Common.haversineMeters(current.lat, current.lon, remaining[0].lat, remaining[0].lon);
      for (let i = 1; i < remaining.length; i++) {
        const dist = Common.haversineMeters(current.lat, current.lon, remaining[i].lat, remaining[i].lon);
        if (dist < nearestDist) {
          nearestDist = dist;
          nearestIdx = i;
        }
      }
      current = remaining[nearestIdx];
      ordered.push(current);
      remaining.splice(nearestIdx, 1);
    }
    // fixedEnd is appended only after the free cities are placed, and only
    // if it's a genuinely different city than fixedStart (a same-city
    // round-trip has nothing to append — fixedStart already covers it).
    if (fixedEnd && fixedEnd !== fixedStart) ordered.push(fixedEnd);
    return Common._twoOptImprove(ordered, { lockEnd: !!fixedEnd && fixedEnd !== fixedStart });
  }

  // Greedy nearest-neighbor alone routinely strands one outlier city (nothing
  // else is ever "nearest" to it) until it's the only one left, forcing a big
  // backtrack at the very end — e.g. Bordeaux picked last after the route has
  // already moved on into Italy, producing "France, France, Italy, Italy,
  // France" instead of two clean per-country legs. A 2-opt pass fixes this:
  // repeatedly reverse any segment of the path that shortens its total
  // length, until no more improving reversal exists. Cheap at this scale (a
  // handful of cities), so no iteration cap is needed. Mutates and returns
  // the same array — safe here since `route` is always a freshly-built array
  // owned by orderCitiesByNearestNeighbor, never the caller's own input.
  //
  // A reversed segment is always route[i+1..j] — index 0 is never inside
  // that range regardless of `i`, so a fixed start city is already safe with
  // no special handling. `lockEnd` caps `j` below the last index so a fixed
  // end city can't be swept into a reversal either.
  static _twoOptImprove(route, { lockEnd = false } = {}) {
    const n = route.length;
    if (n < 4) return route;
    const dist = (a, b) => Common.haversineMeters(a.lat, a.lon, b.lat, b.lon);
    const maxJ = lockEnd ? n - 2 : n - 1;
    let improved = true;
    while (improved) {
      improved = false;
      for (let i = 0; i < n - 2; i++) {
        for (let j = i + 2; j <= maxJ; j++) {
          const hasTail = j < n - 1;
          const before = dist(route[i], route[i + 1]) + (hasTail ? dist(route[j], route[j + 1]) : 0);
          const after = dist(route[i], route[j]) + (hasTail ? dist(route[i + 1], route[j + 1]) : 0);
          if (after < before - 1) {
            let lo = i + 1;
            let hi = j;
            while (lo < hi) {
              const tmp = route[lo];
              route[lo] = route[hi];
              route[hi] = tmp;
              lo++;
              hi--;
            }
            improved = true;
          }
        }
      }
    }
    return route;
  }

  // Splits `totalDays` across `cities` proportional to each entry's
  // `popularity`, minimum `minDays` each (default 1), using the
  // largest-remainder method so the returned counts always sum to exactly
  // `totalDays` (plain rounding can drift a day off in either direction).
  // Returns an array of integers index-aligned with `cities`, not the
  // cities themselves. Caller is responsible for ensuring
  // `cities.length * minDays <= totalDays` — this doesn't reduce city count
  // to make room.
  static allocateDaysByPopularity(cities, totalDays, minDays = 1) {
    const n = cities.length;
    if (n === 0) return [];
    if (n * minDays >= totalDays) return cities.map(() => minDays); // no room to weight beyond the floor
    const totalPopularity = cities.reduce((sum, c) => sum + (c.popularity || 1), 0) || n;
    const remainingDays = totalDays - n * minDays; // minDays/city already guaranteed
    const raw = cities.map((c) => (remainingDays * (c.popularity || 1)) / totalPopularity);
    const floors = raw.map((r) => Math.floor(r));
    let allocated = floors.reduce((a, b) => a + b, 0);
    const remainders = raw.map((r, i) => ({ i, frac: r - floors[i] })).sort((a, b) => b.frac - a.frac);
    let leftover = remainingDays - allocated;
    for (let k = 0; k < remainders.length && leftover > 0; k++) {
      floors[remainders[k].i]++;
      leftover--;
    }
    return floors.map((f) => f + minDays);
  }

  // Google Places returns multiple types per place, and — contrary to what
  // Google's own docs imply — they are NOT reliably ordered most-specific
  // first: the Colosseum comes back as ["historical_landmark",
  // "tourist_attraction", ...] with no "museum" tag at all, and Castel
  // Sant'Angelo as ["castle", "historical_landmark", ..., "museum", ...] —
  // taking just the first recognized type picked the generic 30-minute
  // "landmark" estimate for both, wildly undercounting a site that's also
  // (or effectively) a full museum. Taking the MAX estimate across every
  // recognized type instead fixes that: a venue tagged both
  // "historical_landmark" and "museum" gets museum-level time regardless of
  // which tag Google happened to list first. Falls back to 30 minutes
  // (Place.js's own constructor default) when nothing in `types` is
  // recognized at all. Still an inherently coarse heuristic — Google's
  // generic tags (historical_landmark, tourist_attraction) cover everything
  // from a 15-minute fountain to a 2-hour amphitheater with no way to tell
  // them apart from type alone; this is a starting estimate, not a
  // precise prediction.
  // Floors `minutes` at MEGA_ATTRACTION_DURATION_MINUTES when `name` matches
  // one of the curated mega-attraction keywords — a standalone method (not
  // folded silently into estimateDurationForTypes) because it also needs to
  // apply to a REAL curated duration pulled from a Featured Guide's own
  // schedule (see parseFeaturedPlace in GooglePlaces.js), not just a
  // type-based guess. A single thin curated sample can undersell a
  // world-famous site just as easily as a generic Google type can — e.g.
  // "Accademia di Belle Arti di Firenze" (a distinct, separately-manifested
  // entry from the more famous "Galleria dell'Accademia") came back with a
  // real but short 60-minute curated median, still well under what a name
  // this recognizable warrants. Exported as its own method so both estimate
  // paths apply the exact same floor.
  static applyMegaAttractionFloor(minutes, name) {
    const nameLower = (name || "").toLowerCase();
    if (nameLower && MEGA_ATTRACTION_NAME_KEYWORDS.some((k) => nameLower.includes(k))) {
      return minutes === null ? MEGA_ATTRACTION_DURATION_MINUTES : Math.max(minutes, MEGA_ATTRACTION_DURATION_MINUTES);
    }
    return minutes;
  }

  // Gives every place that has no visit length of its own (DurationUnset,
  // still sitting at the 30-minute filler) an estimate before a schedule is
  // built from it: the same type-based estimate Google places get, with the
  // guide's category names standing in for Google's type keys ("Museum" →
  // "museum"). Without it, a guide whose places were never given a length —
  // the script-made city guides, most older guides — built into a day of
  // flat half-hour stops (found on Victoria, 2026-10-13). The estimate
  // becomes the place's own length, so later builds agree with this one; a
  // length somebody set is never touched. Returns how many were filled in.
  static estimateUnsetDurations(places, categories) {
    const names = new Map((categories || []).map((c) => [String(c.id), String(c.name || "").toLowerCase().replace(/[^a-z0-9]+/g, "_")]));
    let n = 0;
    (places || []).forEach((p) => {
      if (!p || p.DurationUnset !== true || p.Duration !== 30) return;
      const typeKeys = (Array.isArray(p.Category) ? p.Category : []).map((id) => names.get(String(id))).filter(Boolean);
      p.Duration = Common.estimateDurationForTypes(typeKeys, p.Name);
      delete p.DurationUnset;
      n++;
    });
    return n;
  }

  static estimateDurationForTypes(types, name) {
    // Flat safety margin added to every result (including the no-match
    // fallback) — a type-based estimate consistently runs a little short in
    // practice (getting oriented, restrooms, a line that wasn't expected),
    // so it's safer to pad every stop a bit than to only pad the ones that
    // look risky.
    const VISIT_PADDING_MINUTES = 10;
    // 60, not something shorter — matches Place.js's own constructor
    // default (raised from 30 to 60 2026-09-01): a wrong-but-short guess
    // understaffs the schedule and pushes everything after it too early,
    // while a wrong-but-long guess just leaves a little slack.
    const UNKNOWN_TYPE_FALLBACK_MINUTES = 60;
    let best = null;
    if (Array.isArray(types)) {
      for (const t of types) {
        if (Object.prototype.hasOwnProperty.call(PLACE_TYPE_DURATIONS, t)) {
          const d = PLACE_TYPE_DURATIONS[t];
          if (best === null || d > best) best = d;
        }
      }
    }
    // Named-override check runs regardless of what (if anything) `types`
    // matched — a mega-attraction mistagged as a generic type still needs
    // the long estimate, and one with no recognized type at all shouldn't
    // fall all the way back to the generic 60-minute default either.
    best = Common.applyMegaAttractionFloor(best, name);
    return (best === null ? UNKNOWN_TYPE_FALLBACK_MINUTES : best) + VISIT_PADDING_MINUTES;
  }

  // Returns `candidate` unchanged if it isn't already in `usedNamesLower`
  // (a Set of lowercased names, mutated in place as names are claimed —
  // pass the same Set across a whole batch of new places so each one sees
  // the names already claimed by earlier ones in that batch, not just
  // pre-existing places). Otherwise bumps a trailing "_N" (or appends one)
  // until it finds a free name. Shared by "Create Journal from Photos" and
  // "Personalize Guide with Photos" so newly-created places never silently
  // collide with an existing place's name (e.g. re-running either flow, or
  // a base name that happens to match something already in the guide).
  static uniquePlaceName(candidate, usedNamesLower) {
    const key = candidate.toLowerCase();
    if (!usedNamesLower.has(key)) {
      usedNamesLower.add(key);
      return candidate;
    }
    const m = candidate.match(/^(.*)_(\d+)$/);
    const base = m ? m[1] : candidate;
    let n = m ? parseInt(m[2], 10) + 1 : 2;
    let next;
    do {
      next = `${base}_${n}`;
      n++;
    } while (usedNamesLower.has(next.toLowerCase()));
    usedNamesLower.add(next.toLowerCase());
    return next;
  }

  // Order-independent, case-insensitive token match — every word of `needle`
  // must appear as a substring somewhere in `haystack`, the same technique
  // CommandPalette.js uses for its literal command search (see that file's
  // comment for the "no real fuzzy/typo tolerance, just order-independent"
  // caveat — this is intentionally the same modest bar, not true fuzzy/
  // edit-distance matching). Used to match a broad category name like
  // "Museum" against a more specific AI/Google/Wikipedia-supplied category
  // string like "Sculpture museum", which a plain case-sensitive
  // haystack.includes(needle) check would miss.
  // Word-boundary match, not raw substring — a raw .includes() let short
  // category names accidentally match inside unrelated words (e.g. needle
  // "Spa" matched haystack "...Autonomous communities of Spain...", "Bar"
  // matched inside "library", "Camp" matched inside "campaign"). Found
  // 2026-08-31 auditing Wikipedia-category-based place categorization — see
  // memory. \b keeps each token an actual whole word in the haystack rather
  // than any substring position. The optional (e?s)? before the closing \b
  // is required, not cosmetic — Wikipedia's own categories are almost
  // always plural ("Museums in X", "Castles in Y") while our category names
  // are singular; a strict \b...\b with no plural allowance dropped the
  // resolved rate from 78% to 42% in testing (measured via
  // scripts/auditWikipediaCategoryMatch.js) by rejecting exactly these
  // singular-needle-vs-plural-haystack matches, without fixing any more
  // false positives than the stricter version already caught.
  static tokenSubstringMatch(needle, haystack) {
    if (!needle || !haystack) return false;
    const h = haystack.toLowerCase();
    const tokens = needle.toLowerCase().split(/\s+/).filter(Boolean);
    return tokens.length > 0 && tokens.every((t) => {
      const escaped = t.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
      return new RegExp(`\\b${escaped}(?:e?s)?\\b`).test(h);
    });
  }

  // Greedy nearest-cluster-centroid grouping of chronologically-sorted,
  // EXIF-geotagged photos — join the nearest existing cluster if within
  // sensitivityMeters of its centroid, else start a new cluster. Not naive
  // consecutive-photo chaining, which would merge an entire day of walking
  // into one "place" since each step is close to the last even as the
  // day's overall span grows huge — but the centroid itself drifts as a
  // cluster grows, so without maxSpanMeters the same snowballing can still
  // happen over more steps (each one near the *current*, moved centroid,
  // even though the cluster's first and last photos end up far apart).
  // maxSpanMeters rejects a join that would stretch the cluster's bounding
  // box beyond that distance, regardless of how close the new photo is to
  // the drifting centroid. Defaults to no cap for callers not yet updated
  // to pass it. Shared here (originally built for the "Create Journal from
  // Photos" rebuild in HomeHeader.js/MobileBottomNavBar.js) so "Personalize
  // Guide with Photos" can cluster photos that don't match any existing
  // place into new-place candidates without duplicating this logic.
  static clusterPhotosByProximity(chronoPhotos, sensitivityMeters, maxSpanMeters = Infinity) {
    const clusters = []; // [{ photos: [...], sumLat, sumLon, minLat, maxLat, minLon, maxLon }]
    chronoPhotos.forEach((photo) => {
      const lat = photo.exif_data.latitude;
      const lon = photo.exif_data.longitude;
      let best = null;
      let bestDist = Infinity;
      clusters.forEach((c) => {
        const centroidLat = c.sumLat / c.photos.length;
        const centroidLon = c.sumLon / c.photos.length;
        const dist = Common.haversineMeters(centroidLat, centroidLon, lat, lon);
        if (dist > sensitivityMeters || dist >= bestDist) return;
        const span = Common.haversineMeters(
          Math.min(c.minLat, lat), Math.min(c.minLon, lon),
          Math.max(c.maxLat, lat), Math.max(c.maxLon, lon)
        );
        if (span > maxSpanMeters) return;
        bestDist = dist;
        best = c;
      });
      if (best) {
        best.photos.push(photo);
        best.sumLat += lat;
        best.sumLon += lon;
        best.minLat = Math.min(best.minLat, lat);
        best.maxLat = Math.max(best.maxLat, lat);
        best.minLon = Math.min(best.minLon, lon);
        best.maxLon = Math.max(best.maxLon, lon);
      } else {
        clusters.push({ photos: [photo], sumLat: lat, sumLon: lon, minLat: lat, maxLat: lat, minLon: lon, maxLon: lon });
      }
    });
    return clusters.map((c) => c.photos);
  }

  static BruteForce = (places) => {
    let perm_arg = [];
    for (let p = 0; p < places.length; p++) {
      perm_arg.push(p);
    }
    let paths = Common.permute(perm_arg);
    let pathData = [];
    let distance = 0;
    for (let i = 0; i < paths.length; i++) {
      let totalDistance = 0;
      for (let j = 0; j < paths[i].length; j++) {
        if (j < paths[i].length - 1) {
          const p1 = { latitude: places[paths[i][j]].Lat, longitude: places[paths[i][j]].Longi };
          const p2 = { latitude: places[paths[i][j + 1]].Lat, longitude: places[paths[i][j + 1]].Longi };
          distance = Common.calculateDistance(p1, p2);
          totalDistance += distance;
        }
      }
      pathData.push({ nodes: paths[i], distance: totalDistance });
    }
    let min_distance = 99999999999999999;
    let index = -1;
    for (let i = 0; i < pathData.length; i++) {
      if (pathData[i].distance < min_distance) {
        min_distance = pathData[i].distance;
        index = i;
      }
    }
    let ordered_places = [];
    if (index === -1) return ordered_places;
    for (let j = 0; j < pathData[index].nodes.length; j++) ordered_places.push(places[pathData[index].nodes[j]]);
    return ordered_places;
  };

  static salesman_js = (places) => {
    var points = [];
    for (let i = 0; i < places.length; i++) {
      points.push(new salesman.Point(places[i].Longi, places[i].Lat));
    }
    var solution = salesman.solve(points, 0.9999);
    // solution is an array of INDEXES into points/places (per salesman.js's
    // own docs — "var ordered_points = solution.map(i => points[i]);") — not
    // a set of new Point objects that need matching back to their source.
    // The previous version re-derived each place by looking up a Lat/Longi
    // coordinate match instead of just using the index directly: two places
    // sharing the same coordinates (e.g. both geocoded to the same piazza —
    // confirmed 2026-09-01 with "Piazzale Michelangelo"/"Museo Nazionale del
    // Duomo") made findIndex always return the FIRST match, so one place got
    // scheduled twice while the other silently never appeared at all.
    //
    // salesman.js optimizes a CLOSED tour — its own cost function
    // (Path.prototype.size, salesman.js source) sums distance(i, i+1) with
    // the index WRAPPING, i.e. it includes the edge from the last point
    // back to the first, as if the day ended where it started. We use the
    // result as a one-way day itinerary with no return trip, so that
    // assumed closing edge is fictitious — if it happens to land elsewhere
    // than at the real outlier, an outlier place (e.g. a stadium miles from
    // an otherwise-clustered city center) can end up stranded in the
    // MIDDLE of the day with two expensive legs on either side, instead of
    // at the start or end where an outlier belongs. A closed tour minus its
    // single longest edge is a good open path: find the most expensive
    // consecutive-or-wraparound edge and cut the cycle there instead of
    // using solution[0] as a fixed (fictitious) start. Found 2026-09-30 via
    // a real Build My Trip day that visited a central cathedral, a nearby
    // ruin, then a stadium ~5km away, then doubled back to a piazza next to
    // the first stop.
    let cutAfter = 0;
    let maxEdge = -1;
    for (let i = 0; i < solution.length; i++) {
      const next = (i + 1) % solution.length;
      const d = Common.calculateDistance(
        { latitude: places[solution[i]].Lat, longitude: places[solution[i]].Longi },
        { latitude: places[solution[next]].Lat, longitude: places[solution[next]].Longi }
      );
      if (d > maxEdge) {
        maxEdge = d;
        cutAfter = i;
      }
    }
    const rotated = [...solution.slice(cutAfter + 1), ...solution.slice(0, cutAfter + 1)];
    return rotated.map((i) => places[i]);
  };

  static getPlaceOrderByDistance = (place_ids, guide_obj, _places) => {
    let places = [];
    if (typeof _places !== "undefined" && _places !== null) {
      places = _places;
    } else if (place_ids !== null && place_ids !== undefined) {
      place_ids.forEach((place_id) => {
        let place = guide_obj.places.getPlace(place_id.value.ID);
        places.push(place);
      });
    } else {
      return [];
    }

    if (places.length < 9) return Common.BruteForce(places);
    else return Common.salesman_js(places);

    //console.log("pathData", pathData);
    //return ordered_places;
  };

  static getFBPath(guide_id, user_info, folder) {
    //if (guide_id == null || user_info.uid == null) return null;
    if (folder != null) return `${folder}/${user_info.uid}/`;
    return `${user_info.uid}/${guide_id}/`;
  }

  static getImageURL(imgURL, xx, _html) {
    // console.log("getImageURL", typeof imgURL);
    // return;
    let html = _html;
    if (window.web_app === true) html = false;
    if (typeof imgURL === "undefined" || imgURL == null || imgURL == "") {
      return "https://andiamotravelapp.com/Images/App/IllustratedImage.jpg";
    }
    if (imgURL === "http://liquidguides.com/Media/Images/google-places-logo.jpg")
      // if (html === false) return google_places_logo;
      return "https://andiamotravelapp.com/Images/App/IllustratedImage.jpg";
    //console.log("imgURL 2");

    if (imgURL === "http://liquidguides.com/Media/Images/place.png")
      // if (html === false) return place_png;
       return "https://andiamotravelapp.com/Images/App/IllustratedImage.jpg";
    //console.log("imgURL 3");
    // if (imgURL.startsWith("http:")) {
    //   console.log("imgURL startsWith http");
    //   return `https://www.google.com/search?q=%${imgURL}`;
    // }
    //console.log("imgURL 4");
    if (typeof imgURL === "object") return imgURL;
    if (typeof imgURL === "string" && imgURL.startsWith("gdrive:")) {
      const fileId = imgURL.slice(7);
      return `https://lh3.googleusercontent.com/d/${fileId}`;
    }
    if (typeof imgURL === "string" && imgURL.indexOf("http") != -1)
      return imgURL.startsWith("http://") ? imgURL.replace("http://", "https://") : imgURL;
    //console.log("imgURL 6");
    if (imgURL === "")
      if (html === false) return place_png;
      else return "https://andiamotravelapp.com/Images/App/IllustratedImage.jpg";
    //console.log("imgURL 7");
    //return place_png;
    return Settings.WEB_SITE + Settings.IMAGE_LOCATION + imgURL;
    // if (imgURL != "") {
    //   if (img.indexOf("http:") == -1) imgURL = Settings.WEB_SITE + Settings.IMAGE_LOCATION + imgURL;
    //   else imgURL = img;
    // } else imgURL = Settings.IMAGE_ASSETS + Settings.PLACE_IMAGE_PLACE_HOLDER;
    //console.log("imgURL", imgURL);
  }

  static adjustDate(date) {
    date = new Date(date);
    var userTimezoneOffset = date.getTimezoneOffset() * 60000;
    date = new Date(date.getTime() - userTimezoneOffset);
    return date;
  }

  static adjustForTimeZone(date, add) {
    //console.log("adjustForTimeZone date1", date);
    date = new Date(date);
    var userTimezoneOffset = date.getTimezoneOffset() * 60000;
    if (add) date = new Date(date.getTime() - userTimezoneOffset);
    else date = new Date(date.getTime() + userTimezoneOffset);
    //console.log("adjustForTimeZone date2", date);
    return date;
  }

  static dateToString(date) {
    //writes string without timezone so that when parsed, it is not adjusted for timezone
    //return `${date.getFullYear()},${date.getMonth()},${date.getDate()},${date.getHours()},${date.getMinutes()}`;
    //2020-12-06T18:00:20.989Z

    // in case it's already a string
    let date2 = new Date(date);

    //console.log("dateToString", date, date2);
    let month = date2.getMonth() + 1;
    month = month < 10 ? `0${month}` : `${month}`;
    let day = date2.getDate();
    day = day < 10 ? `0${day}` : `${day}`;
    let hours = date2.getHours();
    hours = hours < 10 ? `0${hours}` : `${hours}`;
    let minutes = date2.getMinutes();
    minutes = minutes < 10 ? `0${minutes}` : `${minutes}`;
    return `${date2.getFullYear()}-${month}-${day}T${hours}:${minutes}:00`;
  }

  static LuxonDateTimeToString(date) {
    const dateString = date.toUTC().toISO();
    const jsdate = new Date(dateString);
    //console.log("LuxonDateTimeToString:", date, dateString, jsdate);
    return jsdate;
  }

  static dateFromString(dateString) {
    return new Date(dateString);
    //var dateParts = dateString.split(",");
    //new Date(dateParts[0], dateParts[1], dateParts[2], dateParts[3], dateParts[4], 0, 0);
  }

  static formatDate(date, noYear, adjust) {
    //console.log("typeof date:", typeof date);
    // if (typeof date == "object") {
    //   this.formatDateLuxon(date, noYear, adjust);
    //   return;
    // }
    date = new Date(date);
    //var userTimezoneOffset = date.getTimezoneOffset() * 60000;
    //date = new Date(date.getTime() - userTimezoneOffset);
    //console.log("date2", date);

    let day = date.getDate();
    day += adjust == true ? 1 : 0;
    if (noYear) return `${Settings.DAYS[date.getDay()]}, ${Settings.MONTHS[date.getMonth()]} ${day}`;
    else return `${Settings.DAYS[date.getDay()]}, ${Settings.MONTHS[date.getMonth()]} ${day}, ${date.getFullYear()}`;
  }

  static formatDateLuxon(date, noYear, adjust) {
    var dateTime = DateTime.fromISO(date, { zone: "utc" });
    if (!dateTime.isValid) return "";
    let day = dateTime.day;
    day += adjust == true ? 1 : 0;

    let returnVal = `${dateTime.toFormat("ccc")}, ${Settings.MONTHS[dateTime.month - 1]} ${day}`;
    if (!noYear) returnVal += `, ${dateTime.year}`;
    //console.log("formatDateLuxon date, dateTime, value:", date, dateTime, returnVal);
    return returnVal;
  }

  // static JSDateToLuxonDateTime(date) {
  //   // Create a JS Date from a Luxon DateTime
  //   const JSDate = new Date(date.valueOf()); // 1516717417146
  //   return JSDate;
  // }

  static JSDateFromLuxonDate(date) {
    const JSDate = new Date(date.year, date.month - 1, date.day, date.hour, date.minute, 0);
    return JSDate;
  }

  static LuxonDateFromJSDate(date) {
    const LuxonDate = DateTime.fromObject(
      {
        year: date.getFullYear(),
        month: date.getMonth() + 1,
        day: date.getDate(),
        hour: date.getHours(),
        minute: date.getMinutes(),
        second: 0,
      },
      { zone: "utc" }
    );
    return LuxonDate;
  }

  static JSDateFromLuxonDateTime(date) {
    // Create a JS Date from a Luxon DateTime
    const JSDate = new Date(date.valueOf()); // 1516717417146
    return JSDate;
  }

  static LuxonDateTimeFromJSDate(date) {
    // Create a Luxon DateTime from a JS Date
    const LuxonDateTime = DateTime.fromMillis(date.getTime(), { zone: "utc" });
    return LuxonDateTime;
  }

  static formatDateYMD(date) {
    //console.log("date1", date);
    date = new Date(date);
    //var userTimezoneOffset = date.getTimezoneOffset() * 60000;
    //date = new Date(date.getTime() - userTimezoneOffset);
    //console.log("date2", date);
    let month = date.getMonth() + 1;
    if (month < 10) month = "0" + month;

    let day = date.getDate();
    if (day < 10) day = "0" + day;
    return `${date.getFullYear()}-${month}-${day}`;
  }

  static formatTime(date, add, seconds) {
    //console.log("formatTime date1", date, add);
    //if (typeof date == "string")
    date = new Date(date);
    if (add == true || add == false) {
      var userTimezoneOffset = date.getTimezoneOffset() * 60000;
      if (add == true) date = new Date(date.getTime() - userTimezoneOffset);
      else date = new Date(date.getTime() + userTimezoneOffset);
    }
    //console.log("formatTime date2", date);
    var minutes = date.getMinutes();
    // if (half == true) {
    //   if (minutes < 15) minutes = 0;
    //   else if (minutes > 45) minutes = 0;
    //   else minutes = 30;
    // }
    if (minutes < 10) minutes = `0${minutes}`;
    if (seconds) {
      seconds = date.getSeconds();
      if (seconds < 10) seconds = `0${seconds}`;
      return `${date.getHours()}:${minutes}:${seconds}`;
    }
    return `${date.getHours()}:${minutes}`;
  }

  static formatTimeLuxon(date) {
    var dateTime = DateTime.fromISO(date, { zone: "utc" });
    if (!dateTime.isValid) return "";
    var minutes = dateTime.minute;
    if (minutes < 10) minutes = `0${minutes}`;
    //console.log("formatTimeLuxon date, dateTime, time", date, dateTime, `${dateTime.hour}:${minutes}`);
    return `${dateTime.hour}:${minutes}`;
  }

  // A shorter form for space-constrained labels like the schedule's opening-
  // hours warning pill ("Opens at 10" / "Closes at 18") — drops the ":00"
  // for on-the-hour times, which is most of them, rather than always
  // showing formatTimeLuxon's full "10:00".
  static formatTimeBrief(date) {
    const dateTime = DateTime.fromISO(date, { zone: "utc" });
    if (!dateTime.isValid) return "";
    if (dateTime.minute === 0) return `${dateTime.hour}`;
    const minutes = dateTime.minute < 10 ? `0${dateTime.minute}` : dateTime.minute;
    return `${dateTime.hour}:${minutes}`;
  }

  static createTextFromHTML(html) {
    // Temporary
    return html;
    if (html == null) return "";
    let text = html.replace(/<style([\s\S]*?)<\/style>/gi, "");
    text = text.replace(/<script([\s\S]*?)<\/script>/gi, "");
    text = text.replace(/<\/div>/gi, "\n");
    text = text.replace(/<\/li>/gi, "\n");
    text = text.replace(/<li>/gi, "  *  ");
    text = text.replace(/<\/ul>/gi, "\n");
    text = text.replace(/<\/p>/gi, "\n");
    text = text.replace(/<br\s*[\/]?>/gi, "\n");
    text = text.replace(/<[^>]+>/gi, "");
    text = text.replace(/&amp/g, "");
    text = text.replace(/&quot/g, '"');
    text = text.replace("&#x200b;", "");
    return text.trim();
  }

  static createHTMLFromText(input_str) {
    //store input
    var text_input; //store input after being trim()med
    var output_html = ""; //store output
    var counter;

    text_input = input_str.trim(); //trim() input
    if (text_input.length > 0) {
      output_html += "<p>"; //begin by creating paragraph
      for (counter = 0; counter < text_input.length; counter++) {
        switch (text_input[counter]) {
          case "\n":
            if (text_input[counter + 1] === "\n") {
              output_html += "</p>\n<p>";
              counter++;
            } else output_html += "<br>";
            break;

          case " ":
            if (text_input[counter - 1] != " " && text_input[counter - 1] != "\t") output_html += " ";
            break;

          case "\t":
            if (text_input[counter - 1] != "\t") output_html += " ";
            break;

          case "&":
            output_html += "&amp;";
            break;

          case '"':
            output_html += "&quot;";
            break;

          case ">":
            output_html += "&gt;";
            break;

          case "<":
            output_html += "&lt;";
            break;

          default:
            output_html += text_input[counter];
        }
      }
      output_html += "</p>"; //finally close paragraph
    }
    return output_html; // return output html
  }

  static addCommas(nStr) {
    nStr += "";
    var x = nStr.split(".");
    var x1 = x[0];
    var x2 = x.length > 1 ? "." + x[1] : "";
    var rgx = /(\d+)(\d{3})/;
    while (rgx.test(x1)) {
      x1 = x1.replace(rgx, "$1" + "," + "$2");
    }
    return x1 + x2;
  }

  static isNumeric(str) {
    if (typeof str != "string") return false; // we only process strings!
    return (
      !isNaN(str) && // use type coercion to parse the _entirety_ of the string (`parseFloat` alone does not do this)...
      !isNaN(parseFloat(str))
    ); // ...and ensure strings of whitespace fail
  }

  static getMaxMinLatLon(allPlaces) {
    let min_lat = 90;
    let min_lon = 180;
    let max_lat = -90;
    let max_lon = -180;
    for (let i = 0; i < allPlaces.length; i++) {
      let lat = 0;
      let lon = 0;
      if (typeof allPlaces[i].data.base_location !== "undefined") {
        lat = allPlaces[i].data.base_location.latitude;
        lon = allPlaces[i].data.base_location.longitude;
      }
      if (lat < min_lat) min_lat = lat;
      if (lat > max_lat) max_lat = lat;
      if (lon < min_lon) min_lon = lon;
      if (lon > max_lon) max_lon = lon;
    }
    const delta = 0.03;
    if (max_lat === min_lat || max_lon === min_lon) {
      min_lat -= delta;
      min_lon -= delta;
      max_lat += delta;
      max_lon += delta;
    }
    //console.log("max_lat:", max_lat, "max_lon:", max_lon, "min_lat:", min_lat, "min_lon:", min_lon);
    const max_mins = { max_lat: max_lat, max_lon: max_lon, min_lat: min_lat, min_lon: min_lon };
    return max_mins;
  }

  static filterGuides = (
    guides,
    guide_search_text,
    guide_countries_selected,
    guide_cities_selected,
    guide_language_selected,
    guide_order_by,
    guide_order_ascending
  ) => {
    // guide_order_ascending is true (normal direction) or false (reversed) — mirrors
    // andiamo-places' toggleSortDirection/_dir pattern so both apps sort the same way.
    const _dir = guide_order_ascending === false ? -1 : 1;
    let guides_to_display = [];
    let found = false;
    const searchUpper = (guide_search_text || "").toUpperCase();
    const languageUpper = (guide_language_selected || "").toUpperCase();
    const filterByLanguage = languageUpper !== "" && languageUpper !== "ALL";
    for (let i = 0; i < guides.length; i++) {
      if (filterByLanguage && !(guides[i].data.language || "").toUpperCase().includes(languageUpper)) continue;
      if (searchUpper !== "") if (!(guides[i].data.guide_name || "").toUpperCase().includes(searchUpper)) continue;
      if (guide_countries_selected.length !== 0) {
        found = false;
        const countries = guides[i].data.countries || [];
        for (let j = 0; j < countries.length; j++) {
          for (let k = 0; k < guide_countries_selected.length; k++) {
            if (guide_countries_selected[k].label.toUpperCase() === (countries[j] || "").toUpperCase()) {
              found = true;
              break;
            }
          }
          if (found === false) break;
        }
        if (found === false) continue;
      }
      if (guide_cities_selected.length !== 0) {
        found = false;
        const cities = guides[i].data.cities || [];
        for (let j = 0; j < cities.length; j++) {
          for (let k = 0; k < guide_cities_selected.length; k++) {
            if (guide_cities_selected[k].label.toUpperCase() === (cities[j] || "").toUpperCase()) {
              found = true;
              break;
            }
          }
          if (found === false) break;
        }
        if (found === false) continue;
      }
      guides_to_display.push(guides[i]);
    }
    if (guide_order_by === "Country")
      guides_to_display = guides_to_display.sort((a, b) =>
        (((a.data.countries || [])[0] || "").toUpperCase() > ((b.data.countries || [])[0] || "").toUpperCase() ? 1 : -1) * _dir
      );
    else if (guide_order_by === "City")
      guides_to_display = guides_to_display.sort((a, b) =>
        (((a.data.cities || [])[0] || "").toUpperCase() > ((b.data.cities || [])[0] || "").toUpperCase() ? 1 : -1) * _dir
      );
    else if (guide_order_by === "Name")
      guides_to_display = guides_to_display.sort((a, b) =>
        ((a.data.guide_name || "").toUpperCase() > (b.data.guide_name || "").toUpperCase() ? 1 : -1) * _dir
      );
    else if (guide_order_by === "Modified date")
      guides_to_display = guides_to_display.sort((a, b) => (a.data.mod < b.data.mod ? 1 : -1) * _dir);
    else if (guide_order_by === "Created date")
      guides_to_display = guides_to_display.sort((a, b) => (a.data.created < b.data.created ? 1 : -1) * _dir);
    else if (guide_order_by === "Rating")
      guides_to_display = guides_to_display.sort((a, b) => (a.data.rating < b.data.rating ? 1 : -1) * _dir);
    else if (guide_order_by === "Times Reviewed")
      guides_to_display = guides_to_display.sort((a, b) => (a.data.num_ratings < b.data.num_ratings ? 1 : -1) * _dir);
    else if (guide_order_by === "Times Read")
      guides_to_display = guides_to_display.sort((a, b) => (a.data.times_read < b.data.times_read ? 1 : -1) * _dir);
    else if (guide_order_by === "Read date")
      guides_to_display = guides_to_display.sort((a, b) => (a.data.read < b.data.read ? 1 : -1) * _dir);
    return guides_to_display;
  };
  // Keeps the cached "Mine"/"Featured" guide list (GuideInfoArrayMine / GuideInfoArray)
  // in sync right after a save, instead of leaving it stale until the next cloud
  // re-fetch. Only patches fields the UI actually edits — leaves server-managed
  // stats (rating, num_ratings, times_read, times_copied, created, read, access,
  // categories, etc.) untouched since a "modify" save doesn't write those.
  static patchGuideInfoEntry = (guide_info_array, guide_info_id, patch) => {
    const index = guide_info_array.findIndex((g) => g.id === guide_info_id);
    if (index === -1) return guide_info_array;
    const updated = guide_info_array.slice();
    updated[index] = { ...updated[index], data: { ...updated[index].data, ...patch } };
    return updated;
  };
  static purchaseTicketsHTML(AppSettings, creator_info, owner_info, user_info) {
    //console.log("owner_info", owner_info);
    //console.log("user_info", user_info);
    //if (creator_info == null) if (owner_info != null) creator_info = owner_info;
    // if (owner_info == null) if (creator_info != null) owner_info = creator_info;
    // if (user_info == null) if (owner_info != null) user_info = owner_info;
    if (creator_info == null) creator_info = { uid: "no_creator_info", affiliate_program: true };
    //console.log("creator_info", creator_info);
    let marker = AppSettings.travel_payouts_marker;
    if (marker == null) marker = "292121";
    let sid = creator_info.affiliate_program === true ? creator_info.uid : "non_participating";
    // This is for tracking sub accounts i.e users
    //let travel_payouts_marker_sid = `${marker}.${sid}`;
    let travel_payouts_marker_sid = `${marker}`;
    let html = AppSettings.tickets || "";
    html = html.replace(/292121/g, travel_payouts_marker_sid);
    //console.log(html);
    // console.log(
    //   `purchaseTicketsHTML creator: ${creator}/${percent_1}, owner: ${owner}/${percent_2}, user: ${user}/${percent_3}, andiamo: ${andiamo}, travel_payouts_marker: ${travel_payouts_marker}`
    // );

    const cssOverride = `
      <style>
        :root {
          --bg: #FAFAFA;
          --surface: #FFFFFF;
          --surface-sunken: #F4F4F5;
          --on-bg: #18181B;
          --on-surface: #18181B;
          --on-surface-muted: #71717A;
          --border: #E4E4E7;
          --accent: #2F6FE5;
          --radius-lg: 20px;
          --radius-md: 10px;
        }
        * { box-sizing: border-box; }
        html, body {
          margin: 0 !important;
          padding: 0 !important;
          background: var(--bg) !important;
          color: var(--on-bg) !important;
          font-family: -apple-system, BlinkMacSystemFont, "SF Pro Text",
            "Helvetica Neue", Arial, sans-serif !important;
          font-size: 16px !important;
          line-height: 1.55 !important;
          -webkit-font-smoothing: antialiased;
        }
        body {
          padding: 24px 20px 48px !important;
        }
        h1, h2, h3 {
          color: var(--on-bg) !important;
          letter-spacing: -0.3px;
          line-height: 1.2;
          margin: 32px 0 12px 0;
        }
        h1 { font-size: 28px; font-weight: 700; margin-top: 0; }
        h2 { font-size: 22px; font-weight: 700; }
        h3 { font-size: 18px; font-weight: 600; }
        p {
          color: var(--on-surface);
          margin: 0 0 16px 0;
          line-height: 1.6;
        }
        a {
          color: var(--accent) !important;
          text-decoration: none !important;
          font-weight: 600;
        }
        a:hover { text-decoration: underline !important; }
        img {
          max-width: 100% !important;
          height: auto !important;
          border-radius: var(--radius-lg);
          display: block;
          margin: 16px auto;
        }
        hr {
          border: 0;
          border-top: 1px solid var(--border);
          margin: 28px 0;
        }
        iframe, embed, object {
          max-width: 100% !important;
          border-radius: var(--radius-md);
          border: 1px solid var(--border);
          margin: 12px 0;
        }
        table {
          width: 100% !important;
          max-width: 100% !important;
          border-collapse: collapse;
          margin: 16px 0;
        }
      </style>
    `;

    return cssOverride + html;

    // let html = AppSettings.tickets;
    let travel_payouts_marker = AppSettings.travel_payouts_marker_2;
    let percent_1 = AppSettings.percent_1;
    let percent_2 = AppSettings.percent_2;
    let percent_3 = AppSettings.percent_3;

    let creator = 0;
    let owner = 0;
    let user = 0;
    if (creator_info != null) {
      if (creator_info.travel_payouts_marker != "") creator = percent_1;
    }
    if (
      owner_info.travel_payouts_marker != "" &&
      owner_info.travel_payouts_marker != creator_info.travel_payouts_marker
    )
      owner = percent_2;
    if (
      user_info.travel_payouts_marker != "" &&
      user_info.travel_payouts_marker != owner_info.travel_payouts_marker &&
      user_info.travel_payouts_marker != creator_info.travel_payouts_marker
    )
      user = percent_3;
    let andiamo = 100 - creator - owner - user;
    if (andiamo != 100) {
      let random = Math.floor(Math.random() * 100 + 1);
      if (creator != 0)
        if (random < creator) travel_payouts_marker = creator_info.travel_payouts_marker;
        else if (owner != 0)
          if (random >= creator && random < creator + owner) travel_payouts_marker = owner_info.travel_payouts_marker;
          else if (user != 0)
            if (random >= creator + owner && random < creator + owner + user)
              travel_payouts_marker = user_info.travel_payouts_marker;
    }
  }
}

export var Settings = {
  APP_IMAGES: "../../common/app_files/img/",
  WEB_SITE: "http://liquidguides.com",
  IMAGE_LOCATION: "/Media/Photos/",
  IMAGE_ASSETS: "../assets/icons/",
  PLACE_IMAGE_PLACE_HOLDER: "place.png",
  MONTHS: ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"],
  DAYS: ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"],
};

export const COLORS = {
  BLUE: "#3598DB",
  DARK_BLUE: "#0645AD",
  DARKER_BLUE: "#0B0080",
  WHITE: "#ffffff",
  GRAY: "#707070",
  LIGHT_GRAY: "#E5E5E5",
  VERY_LIGHT_GRAY: "#F0F0F0",
  GREEN: "#42BC42",
  YELLOW: "#FFD153",
  ORANGE: "#FFA021",
  RED: "#FF3F3E",
  BLACK: "#000000",
};

export const AUTHORIZATION_LEVEL = {
  NONE: 0,
  READ: 1,
  GUEST: 2,
  COPY: 3,
  MODIFY: 4,
};

// Shared by HomeHeader.js/MobileBottomNavBar.js's version gate — matches
// mobile's identical helper in MainScreen.js. Dotted numeric version strings
// only (e.g. "1.2.3"), missing components compare as 0. Returns true when
// `current` is older than `minRequired`. Requested 2026-09-28 — see project
// memory: project_firestore_rules_hardening.
export const isVersionBelow = (current, minRequired) => {
  const a = (current || "0").split(".").map((n) => parseInt(n, 10) || 0);
  const b = (minRequired || "0").split(".").map((n) => parseInt(n, 10) || 0);
  const len = Math.max(a.length, b.length);
  for (let i = 0; i < len; i++) {
    const av = a[i] || 0;
    const bv = b[i] || 0;
    if (av !== bv) return av < bv;
  }
  return false;
};

export const SAMPLE_GUIDE_ID = "JRm5fzCadsiWIYynzZoJ";

// PHP endpoints live at both /api (production) and /api-dev (a mirror kept
// in sync manually, per repo) so testing changes locally/on a dev deploy
// can't accidentally hit or corrupt state real users depend on. `npm start`
// (CRA dev server) and any non-production build target api-dev; only an
// actual production build (`npm run build`) targets the real api. Every
// client call to a src/dataBase/api/*.php endpoint should build its URL from
// this instead of hardcoding "https://andiamotravelapp.com/api". Added
// 2026-08-28.
export const API_BASE_URL = process.env.NODE_ENV === "production"
  ? "https://andiamotravelapp.com/api"
  : "https://andiamotravelapp.com/api-dev";

// Ordered list of backends to try, in order, for place text-search + hours
// data and for photo lookups — see GooglePlaces.js's searchPlacesNewAPI and
// getPhotoProviderChain, the two places that read this. "google" is the
// official, billed Places API (New); "hasdata" and "openwebninja" are
// unofficial (non-Google-licensed) scraper-backed alternatives already
// evaluated for cost — see project memory:
// project_paid_api_cost_mitigation_analysis. Every caller of
// searchPlacesNewAPI/searchCityAttractions/fetchOpeningHours/
// getPhotoProviderChain is unaffected by this list's contents — they all
// get back the same Place[]/photo shape regardless of which provider
// actually answered the call, and a genuine upstream failure on any entry
// transparently moves on to the next one rather than surfacing an empty
// result (see searchPlacesNewAPI's per-provider onFailure param). A
// provider with no adapter for the method being tried (e.g. "google" has
// no cheap photo endpoint) is simply skipped, not treated as a failure.
// Default flipped to lead with "openwebninja" 2026-09-24 after its $25/mo
// Pro subscription went live and its request/response shape was fully
// confirmed against real traffic (see the Traveler Cost Ledger artifact and
// project memory for the verification log) — override at build time with
// REACT_APP_PLACES_PROVIDER_ORDER="openwebninja,google" (comma-separated,
// any order/subset of "openwebninja"/"hasdata"/"google") in .env if needed.
// REACT_APP_PLACES_PROVIDER (single value, no fallback) is still honored as
// a one-release back-compat shim for an unmigrated .env.
export const PLACES_PROVIDER_ORDER = (
  process.env.REACT_APP_PLACES_PROVIDER_ORDER || process.env.REACT_APP_PLACES_PROVIDER || "openwebninja,google"
)
  .toLowerCase()
  .split(",")
  .map((s) => s.trim())
  .filter(Boolean);

export const ICON_NAMES = [
  "airport",
  "arbol",
  "arch",
  "art-museum-2",
  "atm-2",
  "bags",
  "bank",
  "bar",
  "barber",
  "bar_coktail",
  "beach",
  "beautifulview",
  "bed_breakfast1-2",
  "bicycle_shop",
  "bigcity",
  "binoculars",
  "boat",
  "bus",
  "bustour",
  "cablecar",
  "campingcar",
  "car",
  "carrental",
  "castle-2",
  "cathedral",
  "caution",
  "cave-2",
  "cemetary",
  "church-2",
  "citysquare",
  "climbing-bentgate_carabiner",
  "coffee",
  "color_green",
  "color_teal",
  "color_blue",
  "color_purple",
  "color_brown",
  "color_red",
  "color_orange",
  "color_light_green",
  "congress",
  "conveniencestore",
  "cruiseship",
  "currencyexchange",
  "dentist",
  "departmentstore",
  "desert-2",
  "doctor",
  "dogs_leash",
  "family",
  "firstaid",
  "home-2",
  "hospital-building",
  "hospital",
  "japanese-food",
  "kayaking",
  "lake",
  "laundromat",
  "letter_a",
  "letter_b",
  "letter_c",
  "letter_d",
  "letter_e",
  "letter_f",
  "letter_g",
  "letter_h",
  "letter_i",
  "letter_j",
  "letter_k",
  "letter_l",
  "letter_m",
  "letter_n",
  "letter_o",
  "letter_p",
  "letter_q",
  "letter_r",
  "letter_s",
  "letter_t",
  "letter_u",
  "letter_v",
  "letter_w",
  "letter_x",
  "letter_y",
  "letter_z",
  "library",
  "lighthouse-2",
  "lodging-2",
  "mall",
  "marina-2",
  "medicine",
  "memorial",
  "monument",
  "mosquee",
  "mountains",
  "museum_archeological",
  "museum_art",
  "museum_crafts",
  "museum_industry",
  "museum_naval",
  "museum_war",
  "number_0",
  "number_1",
  "number_10",
  "number_100",
  "number_11",
  "number_12",
  "number_13",
  "number_14",
  "number_15",
  "number_16",
  "number_17",
  "number_18",
  "number_19",
  "number_2",
  "number_20",
  "number_21",
  "number_22",
  "number_23",
  "number_24",
  "number_25",
  "number_26",
  "number_27",
  "number_28",
  "number_29",
  "number_3",
  "number_30",
  "number_31",
  "number_32",
  "number_33",
  "number_34",
  "number_35",
  "number_36",
  "number_37",
  "number_38",
  "number_39",
  "number_4",
  "number_40",
  "number_41",
  "number_42",
  "number_43",
  "number_44",
  "number_45",
  "number_46",
  "number_47",
  "number_48",
  "number_49",
  "number_5",
  "number_50",
  "number_51",
  "number_52",
  "number_53",
  "number_54",
  "number_55",
  "number_56",
  "number_57",
  "number_58",
  "number_59",
  "number_6",
  "number_60",
  "number_61",
  "number_62",
  "number_63",
  "number_64",
  "number_65",
  "number_66",
  "number_67",
  "number_68",
  "number_69",
  "number_7",
  "number_70",
  "number_71",
  "number_72",
  "number_73",
  "number_74",
  "number_75",
  "number_76",
  "number_77",
  "number_78",
  "number_79",
  "number_8",
  "number_80",
  "number_81",
  "number_82",
  "number_83",
  "number_84",
  "number_85",
  "number_86",
  "number_87",
  "number_88",
  "number_89",
  "number_9",
  "number_90",
  "number_91",
  "number_92",
  "number_93",
  "number_94",
  "number_95",
  "number_96",
  "number_97",
  "number_98",
  "number_99",
  "parkinggarage",
  "pets",
  "playground",
  "recycle",
  "regroup",
  "repair",
  "resort",
  "restaurant_chinese",
  "restaurant_fish",
  "restaurant_greek",
  "restaurant_indian",
  "restaurant_italian",
  "restaurant_korean",
  "restaurant_mediterranean",
  "restaurant_mexican",
  "restaurant_thai",
  "restaurant_vegetarian",
  "river-2",
  "road",
  "sandwich-2",
  "school",
  "skiing",
  "stadium",
  "supermarket",
  "taxi",
  "temple-2",
  "toilets_inclusive",
  "train",
  "tramway",
  "tree",
  "veterinary",
  "villa",
  "walkingtour",
  "winebar",
  "zoo",
];

// export const POI_IMAGESXXX = {
//   0: { name: "_None", req: null },
//   1: { name: "_Default", req: require("../assets/images/poi.png") },
//   2: { name: "Accomodations", req: require("../assets/icons/hotel.png") },
//   3: { name: "Architecture", req: require("../assets/icons/arch.png") },
//   4: { name: "Area", req: require("../assets/icons/citysquare.png") },
//   5: { name: "Attraction", req: require("../assets/icons/congress.png") },
//   6: { name: "City", req: require("../assets/icons/bigcity.png") },
//   7: { name: "Entertainment", req: require("../assets/icons/theater.png") },
//   8: { name: "Family & Kids", req: require("../assets/icons/family.png") },
//   9: { name: "Historical", req: require("../assets/icons/historical_museum.png") },
//   10: { name: "Landmark", req: require("../assets/icons/landmark.png") },
//   11: { name: "Museum", req: require("../assets/icons/temple-2.png") },
//   12: { name: "Nearby", req: require("../assets/icons/sight-2.png") },
//   13: { name: "Neighborhood", req: require("../assets/icons/citysquare.png") },
//   14: { name: "Religion", req: require("../assets/icons/cathedral.png") },
//   15: { name: "Restaurants", req: require("../assets/icons/restaurant.png") },
//   16: { name: "Shopping", req: require("../assets/icons/bags.png") },
//   17: { name: "Sport", req: require("../assets/icons/stadium.png") },
//   18: { name: "Transport", req: require("../assets/icons/bus.png") },
// };
export const POI_IMAGES = {
  0: { name: "None", req: null },
  1: { name: "Default", req: poi },
  2: { name: "airport", req: airport },
  3: { name: "tree", req: arbol },
  4: { name: "arch", req: arch },
  5: { name: "art museum", req: art_museum_2 },
  6: { name: "atm", req: atm_2 },
  7: { name: "bags", req: bags },
  8: { name: "bank", req: bank },
  9: { name: "bar", req: bar },
  10: { name: "barber", req: barber },
  11: { name: "bar cocktail", req: bar_coktail },
  12: { name: "beach", req: beach },
  13: { name: "beautiful view", req: beautifulview },
  14: { name: "bed and breakfast", req: bed_breakfast1_2 },
  15: { name: "bicycle", req: bicycle_shop },
  16: { name: "big city", req: bigcity },
  17: { name: "binoculars", req: binoculars },
  18: { name: "boat", req: boat },
  19: { name: "bus", req: bus },
  20: { name: "bus tour", req: bustour },
  21: { name: "cable car", req: cablecar },
  22: { name: "camping", req: campingcar },
  23: { name: "car", req: car },
  24: { name: "car rental", req: carrental },
  25: { name: "castle", req: castle_2 },
  26: { name: "cathedral", req: cathedral },
  27: { name: "caution", req: caution },
  28: { name: "cave", req: cave_2 },
  29: { name: "cemetery", req: cemetary },
  30: { name: "church", req: church_2 },
  31: { name: "city square", req: citysquare },
  32: { name: "climbing", req: climbing_bentgate_carabiner },
  33: { name: "coffee", req: coffee },
  34: { name: "congress", req: congress },
  35: { name: "convenience store", req: conveniencestore },
  36: { name: "cruise ship", req: cruiseship },
  37: { name: "currency exchange", req: currencyexchange },
  38: { name: "dentist", req: dentist },
  39: { name: "department store", req: departmentstore },
  40: { name: "desert", req: desert_2 },
  41: { name: "doctor", req: doctor },
  42: { name: "dogs", req: dogs_leash },
  43: { name: "family", req: family },
  44: { name: "first aid", req: firstaid },
  45: { name: "home", req: home_2 },
  46: { name: "hospital building", req: hospital_building },
  47: { name: "hospital", req: hospital },
  48: { name: "japanese food", req: japanese_food },
  49: { name: "kayaking", req: kayaking },
  50: { name: "lake", req: lake },
  51: { name: "laundromat", req: laundromat },
  52: { name: "letter_a", req: letter_a },
  53: { name: "letter_b", req: letter_b },
  54: { name: "letter_c", req: letter_c },
  55: { name: "letter_d", req: letter_d },
  56: { name: "letter_e", req: letter_e },
  57: { name: "letter_f", req: letter_f },
  58: { name: "letter_g", req: letter_g },
  59: { name: "letter_h", req: letter_h },
  60: { name: "letter_i", req: letter_i },
  61: { name: "letter_j", req: letter_j },
  62: { name: "letter_k", req: letter_k },
  63: { name: "letter_l", req: letter_l },
  64: { name: "letter_m", req: letter_m },
  65: { name: "letter_n", req: letter_n },
  66: { name: "letter_o", req: letter_o },
  67: { name: "letter_p", req: letter_p },
  68: { name: "letter_q", req: letter_q },
  69: { name: "letter_r", req: letter_r },
  70: { name: "letter_s", req: letter_s },
  71: { name: "letter_t", req: letter_t },
  72: { name: "letter_u", req: letter_u },
  73: { name: "letter_v", req: letter_v },
  74: { name: "letter_w", req: letter_w },
  75: { name: "letter_x", req: letter_x },
  76: { name: "letter_y", req: letter_y },
  77: { name: "letter_z", req: letter_z },
  78: { name: "library", req: library },
  79: { name: "lighthouse", req: lighthouse_2 },
  80: { name: "lodging", req: lodging_2 },
  81: { name: "mall", req: mall },
  82: { name: "marina", req: marina_2 },
  83: { name: "medicine", req: medicine },
  84: { name: "memorial", req: memorial },
  85: { name: "monument", req: monument },
  86: { name: "mosque", req: mosquee },
  87: { name: "mountains", req: mountains },
  88: { name: "museum archeological", req: museum_archeological },
  89: { name: "museum art", req: museum_art },
  90: { name: "museum crafts", req: museum_crafts },
  91: { name: "museum industry", req: museum_industry },
  92: { name: "museum naval", req: museum_naval },
  93: { name: "museum war", req: museum_war },
  94: { name: "number_0", req: number_0 },
  95: { name: "number_1", req: number_1 },
  96: { name: "number_2", req: number_2 },
  97: { name: "number_3", req: number_3 },
  98: { name: "number_4", req: number_4 },
  99: { name: "number_5", req: number_5 },
  100: { name: "number_6", req: number_6 },
  101: { name: "number_7", req: number_7 },
  102: { name: "number_8", req: number_8 },
  103: { name: "number_9", req: number_9 },
  104: { name: "parking garage", req: parkinggarage },
  105: { name: "pets", req: pets },
  106: { name: "playground", req: playground },
  107: { name: "recycle", req: recycle },
  108: { name: "regroup", req: regroup },
  109: { name: "repair", req: repair },
  110: { name: "resort", req: resort },
  111: { name: "restaurant chinese", req: restaurant_chinese },
  112: { name: "restaurant fish", req: restaurant_fish },
  113: { name: "restaurant greek", req: restaurant_greek },
  114: { name: "restaurant indian", req: restaurant_indian },
  115: { name: "restaurant italian", req: restaurant_italian },
  116: { name: "restaurant korean", req: restaurant_korean },
  117: { name: "restaurant mediterranean", req: restaurant_mediterranean },
  118: { name: "restaurant mexican", req: restaurant_mexican },
  119: { name: "restaurant thai", req: restaurant_thai },
  120: { name: "restaurant vegetarian", req: restaurant_vegetarian },
  121: { name: "river", req: river_2 },
  122: { name: "road", req: road },
  123: { name: "sandwich", req: sandwich_2 },
  124: { name: "school", req: school },
  125: { name: "skiing", req: skiing },
  126: { name: "stadium", req: stadium },
  127: { name: "supermarket", req: supermarket },
  128: { name: "taxi", req: taxi },
  129: { name: "temple", req: temple_2 },
  130: { name: "toilets", req: toilets_inclusive },
  131: { name: "train", req: train },
  132: { name: "tramway", req: tramway },
  133: { name: "tree", req: tree },
  134: { name: "veterinary", req: veterinary },
  135: { name: "villa", req: villa },
  136: { name: "walking tour", req: walkingtour },
  137: { name: "wine bar", req: winebar },
  138: { name: "zoo", req: zoo },
  139: { name: "restaurant", req: restaurant },
  140: { name: "hotel", req: hotel },
  141: { name: "theater", req: theater },
  142: { name: "bridge", req: bridge_modern },
  143: { name: "ice cream", req: icecream },
  144: { name: "soccer", req: soccer },
  145: { name: "golf", req: golf_2 },
  146: { name: "area", req: area },
  147: { name: "excursion", req: excursion },
  148: { name: "fast food", req: fast_food },
  149: { name: "kids", req: kids },
  150: { name: "leisure", req: leisure },
  151: { name: "nearby", req: nearby },
  152: { name: "neighborhood", req: neighborhood },
  153: { name: "nightlife", req: nightlife },
  154: { name: "outdoors", req: outdoors },
  155: { name: "restaurant french", req: restaurant_french },
  156: { name: "restaurant japanese", req: restaurant_japanese },
  157: { name: "restaurant pizza", req: restaurant_pizza },
  158: { name: "restaurant vegan", req: restaurant_vegan },
  159: { name: "shopping", req: shopping },
  160: { name: "sports", req: sports },
  161: { name: "tour", req: tour },
  162: { name: "trail", req: trail },
  163: { name: "trip", req: trip },
  164: { name: "country", req: country },
  165: { name: "search", req: search },
  166: { name: "bakery", req: bakery },
  167: { name: "restaurant meat", req: restaurant_steakhouse },
  168: { name: "restaurant venezuela", req: restaurant_venezuela },
  169: { name: "color green", req: color_green },
  170: { name: "color teal", req: color_teal },
  171: { name: "color blue", req: color_blue },
  172: { name: "color purple", req: color_purple },
  173: { name: "color brown", req: color_brown },
  174: { name: "color red", req: color_red },
  175: { name: "color orange", req: color_orange },
  176: { name: "color light green", req: color_light_green },
  177: { name: "town", req: town },
  178: { name: "bear", req: bear },
  179: { name: "bridge old", req: bridge_old },
  180: { name: "canyon", req: canyon_2 },
  181: { name: "cinema", req: cinema },
  182: { name: "dancinghall", req: dancinghall },
  183: { name: "deer", req: deer },
  184: { name: "fishing", req: fishing },
  185: { name: "geyser", req: geyser_2 },
  186: { name: "glacier", req: glacier_2 },
  187: { name: "historical_museum", req: historical_museum },
  188: { name: "hotspring", req: hotspring },
  189: { name: "moose", req: moose },
  190: { name: "museum_science", req: museum_science },
  191: { name: "music_classical", req: music_classical },
  192: { name: "palace", req: palace_2 },
  193: { name: "panoramicview", req: panoramicview },
  194: { name: "ruins", req: ruins_2 },
  195: { name: "attraction", req: sight_2 },
  196: { name: "smallcity", req: smallcity },
  197: { name: "state", req: state },
  198: { name: "statue", req: statue_2 },
  199: { name: "synagogue", req: synagogue_2 },
  200: { name: "volcano", req: volcano_2 },
  201: { name: "waterfall", req: waterfall_2 },
  202: { name: "wetlands", req: wetlands },
  203: { name: "world", req: world },
  204: { name: "star", req: star_3 },
  205: { name: "island", req: island_icon },
  206: { name: "building", req: building },
  207: { name: "casino", req: casino_2 },
  208: { name: "photo", req: photo },
  209: { name: "audio", req: audio },
  210: { name: "video", req: video },
  211: { name: "info", req: information },
  212: { name: "garden", req: garden },
  213: { name: "forest", req: forest },
  214: { name: "aquarium", req: aquarium },
  215: { name: "themepark", req: themepark },
  216: { name: "climbing", req: climbing },
  217: { name: "horse", req: horse },
  218: { name: "boat", req: boat },
  219: { name: "surfing", req: surfing },
  220: { name: "farm", req: farm },
  221: { name: "factory", req: factory },
  222: { name: "science", req: science },
  223: { name: "art", req: art },
  224: { name: "observatory", req: observatory },
  225: { name: "brewery", req: brewery },
};

export const AICategories = [
  { category: "Museum", id: "22" },
  { category: "Park", id: "28" },
  { category: "Historic Site", id: "15" },
  { category: "Zoo", id: "101" },
  { category: "Beach", id: "5" },
  { category: "Garden", id: "121" },
  { category: "Outdoors", id: "26" },
  { category: "Sightseeing", id: "143" },
  // Single word (not "Tourist Attraction") so tokenSubstringMatch's
  // every-token requirement only needs "attraction" present, not both
  // words literally adjacent — catches Google's own generic
  // "tourist_attraction" type (→ "tourist attraction" after
  // mapGoogleTypesToCategoryId's underscore-to-space swap) as well as
  // OpenWeb Ninja's identical "Tourist attraction" subtype. Found
  // 2026-09-24: this taxonomy had no entry at all for arguably the single
  // most common type either source returns for exactly the kind of place
  // this app is built around (e.g. "Birds of Eden" bird sanctuary came back
  // uncategorized — its only types were "Tourist attraction"/"Animal
  // protection organization", neither matching any existing category name).
  // Mapped to Sightseeing (143) as the closest existing baseline category
  // — this is only the code-level fallback used before Firestore's
  // settings/settings doc loads; the live AICategories/AIBaseCategories
  // used at runtime need the same entry added there directly (Firestore
  // console, not something this session can write to).
  { category: "Attraction", id: "143" },
  { category: "Monument", id: "21" },
  { category: "Church", id: "8" },
  { category: "Temple", id: "8" },
  { category: "Cathedral", id: "81" },
  { category: "Basilica", id: "81" },
  { category: "Castle", id: "80" },
  { category: "Palace", id: "27" },
  { category: "Square", id: "44" },
  { category: "Amusement Park", id: "124" },
  { category: "Nature Center", id: "28" },
  { category: "Wildlife Sanctuary", id: "62" },
  // tokenSubstringMatch requires EVERY word of the category label to appear
  // in the SAME single type/subtype string — "Wildlife Sanctuary"/"Nature
  // Reserve" above never match a vendor type like "Safari" or "Game
  // reserve" alone, even though semantically they're the same kind of
  // place. Real report: "Aquila Private Game Reserve safari" resolving to
  // no category at all. Found 2026-09-24.
  { category: "Safari", id: "62" },
  { category: "Game Reserve", id: "62" },
  { category: "Art Gallery", id: "145" },
  { category: "Art Tour", id: "145" },
  { category: "Library", id: "88" },
  { category: "Bridge", id: "6" },
  { category: "Botanical Garden", id: "121" },
  { category: "National Park", id: "28" },
  { category: "Nature Reserve", id: "28" },
  { category: "Waterfall", id: "75" },
  { category: "Cave", id: "82" },
  { category: "Lighthouse", id: "89" },
  { category: "Observatory", id: "146" },
  { category: "Planetarium", id: "147" },
  { category: "Memorial", id: "21" },
  { category: "Fort", id: "153" },
  { category: "Monorail", id: "154" },
  { category: "Scenic Drive", id: "155" },
  { category: "Scenic", id: "68" },
  { category: "Ski Resort", id: "116" },
  { category: "Shopping Center", id: "110" },
  { category: "Theater", id: "46" },
  { category: "Concert Hall", id: "108" },
  { category: "Sports Venue", id: "156" },
  { category: "Sports", id: "43" },
  { category: "Casino", id: "115" },
  { category: "Wine", id: "148" },
  { category: "Winery", id: "141" },
  { category: "Wine Tasting", id: "148" },
  { category: "Brewery", id: "149" },
  { category: "Distillery", id: "150" },
  { category: "Race Track", id: "142" },
  { category: "Golf Course", id: "17" },
  { category: "Hiking Trail", id: "151" },
  { category: "Hiking", id: "152" },
  { category: "Horseback Riding", id: "129" },
  { category: "Boating", id: "130" },
  { category: "Fishing", id: "63" },
  { category: "Swimming", id: "131" },
  { category: "Surfing", id: "132" },
  { category: "Kayaking", id: "126" },
  { category: "Canoeing", id: "126" },
  { category: "Rafting", id: "126" },
  { category: "Hot Air Ballooning", id: "43" },
  { category: "Zip Lining", id: "43" },
  { category: "Rock Climbing", id: "127" },
  { category: "Biking", id: "128" },
  { category: "Cycling", id: "128" },
  { category: "Camping", id: "79" },
  { category: "ATV Riding", id: "43" },
  { category: "Paintball", id: "43" },
  { category: "Go-Karting", id: "43" },
  { category: "Ice Skating", id: "43" },
  { category: "Horse Racing", id: "133" },
  { category: "Miniature Golf", id: "17" },
  { category: "Water Park", id: "124" },
  { category: "Airport", id: "1" },
  { category: "Marina", id: "90" },
  { category: "Farm", id: "134" },
  { category: "Factory", id: "135" },
  { category: "University", id: "111" },
  { category: "College", id: "111" },
  { category: "School", id: "111" },
  { category: "Library", id: "88" },
  { category: "Restaurant", id: "29" },
  // TripAI labels meal entries with Category "Breakfast"/"Lunch"/"Dinner"
  // (not a real vendor type) rather than the restaurant/cafe's actual
  // category, and Google Places search can still fail on a given meal
  // entry the same way it can for an attraction — without these, that
  // fallback place would end up with no category at all, same as the
  // travel-leg "no category" symptom. Found 2026-09-30.
  { category: "Breakfast", id: "29" },
  { category: "Lunch", id: "29" },
  { category: "Dinner", id: "29" },
  { category: "Bar", id: "55" },
  { category: "Nightclub", id: "25" },
  { category: "Nightlife", id: "25" },
  { category: "Coffee Shop", id: "83" },
  { category: "Brewpub", id: "55" },
  { category: "Music Venue", id: "67" },
  { category: "Cinema", id: "60" },
  { category: "Art Museum", id: "145" },
  { category: "Science Museum", id: "137" },
  { category: "Children's Museum", id: "22" },
  { category: "Village Tour", id: "59" },
  { category: "Viewpoint", id: "68" },
  { category: "Villa Tour", id: "27" },
  { category: "Promontory", id: "112" },
  { category: "Mountain", id: "92" },
  { category: "City", id: "9" },
  { category: "City Sightseeing", id: "9" },
  { category: "Village", id: "59" },
  { category: "Town", id: "59" },
  { category: "Historical Site", id: "15" },
  { category: "Spa", id: "163" },
  { category: "Food", id: "31" },
  { category: "Shopping", id: "110" },
  { category: "Entertainment", id: "12" },
  { category: "Accomodation", id: "0" },
  { category: "Accommodation", id: "0" },
  { category: "Arts", id: "3" },
  { category: "Bank", id: "4" },
  { category: "Cemetery", id: "7" },
  { category: "Hotel", id: "16" },
  { category: "Leisure", id: "19" },
  { category: "Market", id: "20" },
  { category: "Neighborhood", id: "24" },
  { category: "Street", id: "45" },
  { category: "Landmark", id: "8" },
  { category: "Religious", id: "109" },
  { category: "Religious Site", id: "109" },
  { category: "Historic", id: "15" },
  { category: "Historical", id: "15" },
  { category: "Art", id: "144" },
  { category: "Nature", id: "26" },
  { category: "Natural", id: "26" },
  { category: "Theme Park", id: "124" },
  { category: "Natural Wonder", id: "26" },
  { category: "Festival", id: "159" },
  { category: "Parade", id: "138" },
  { category: "Carnival", id: "139" },
  { category: "Fair", id: "140" },
  { category: "Lake", id: "78" },
  { category: "Stadium", id: "125" },
  { category: "Ancient Ruin", id: "69" },
  { category: "Adventure", id: "13" },
  { category: "Culture", id: "51" },
  { category: "Cultural", id: "51" },
  { category: "Relaxation", id: "19" },
  { category: "Island", id: "113" },

  //{ category: "Military Bases", id: "" },

  // Added 2026-08-31 to close real gaps found against Google's Place Types
  // vocabulary — either a type with no existing match at all ("Tourist
  // Attraction" is on nearly every notable place and had none), or one
  // whose exact wording doesn't substring-match an existing entry after
  // Google's raw type's underscores become spaces (e.g. "night_club" ->
  // "night club" never matched the existing single-word "Nightclub").
  // mapGoogleTypesToCategoryId itself is unchanged — this only adds more
  // {category, id} entries for it to already-correctly loop over.
  { category: "Tourist Attraction", id: "143" },
  { category: "Lodging", id: "16" },
  { category: "Place Of Worship", id: "8" },
  { category: "Mosque", id: "8" },
  { category: "Synagogue", id: "8" },
  { category: "Hindu Temple", id: "8" },
  { category: "Movie Theater", id: "60" },
  { category: "Night Club", id: "25" },
  { category: "Campground", id: "79" },
  { category: "Aquarium", id: "123" },
  { category: "Amusement Center", id: "124" },
  { category: "Plaza", id: "44" },
  { category: "Bed And Breakfast", id: "16" },
  { category: "Motel", id: "16" },
  { category: "Guest House", id: "16" },
  { category: "Hostel", id: "16" },
  { category: "Cottage", id: "16" },
  { category: "Vineyard", id: "141" },
  { category: "Amphitheatre", id: "108" },
  { category: "Opera House", id: "108" },
  { category: "Opera", id: "108" },

  // Added 2026-08-31, mined from real unresolved Featured-guide place names
  // (see scripts/auditUncategorizedFeaturedPlaces.js) — either a British
  // spelling variant that doesn't substring-match its American counterpart
  // ("Theatre" vs "Theater"), or a genuinely uncovered descriptive word.
  { category: "Theatre", id: "46" },
  { category: "Shrine", id: "8" },
  { category: "Monastery", id: "8" },
  { category: "Abbey", id: "8" },
  { category: "Tower", id: "8" },
  { category: "Citadel", id: "153" },
  { category: "Pyramid", id: "69" },
  { category: "Mausoleum", id: "69" },
  { category: "Common", id: "28" },
  { category: "Arboretum", id: "121" },
  { category: "Canyon", id: "26" },
  { category: "View Point", id: "68" },
  { category: "Arena", id: "125" },
  { category: "Pagoda", id: "8" },
];

export const AIBaseCategories = [
  // See AICategories' "Attraction" entry above for why this exists.
  { category: "Attraction", id: "143" },
  { category: "Wildlife", id: "62" },
  { category: "Aquarium", id: "123" },
  { category: "Forest", id: "122" },
  { category: "Garden", id: "121" },
  { category: "Island", id: "113" },
  { category: "Museum", id: "22" },
  { category: "Park", id: "28" },
  { category: "Historic", id: "15" },
  { category: "Zoo", id: "101" },
  { category: "Beach", id: "5" },
  { category: "Garden", id: "121" },
  { category: "Outdoors", id: "26" },
  { category: "Sightseeing", id: "143" },
  { category: "Monument", id: "21" },
  { category: "Church", id: "8" },
  { category: "Cathedral", id: "81" },
  { category: "Basilica", id: "81" },
  { category: "Castle", id: "80" },
  { category: "Palace", id: "27" },
  { category: "Square", id: "44" },
  { category: "Nature", id: "160" },
  { category: "Wild", id: "62" },
  { category: "Art", id: "144" },
  { category: "Library", id: "88" },
  { category: "Bridge", id: "6" },
  { category: "Botanical", id: "167" },
  { category: "Waterfall", id: "75" },
  { category: "Cave", id: "82" },
  { category: "Lighthouse", id: "89" },
  { category: "Memorial", id: "21" },
  { category: "Scenic", id: "68" },
  { category: "Ski", id: "116" },
  { category: "Shop", id: "110" },
  { category: "Theater", id: "46" },
  { category: "Concert", id: "108" },
  { category: "Sport", id: "43" },
  { category: "Casino", id: "115" },
  { category: "Wine", id: "148" },
  { category: "Brewery", id: "149" },
  { category: "Race", id: "142" },
  { category: "Golf", id: "17" },
  { category: "Hiking", id: "152" },
  { category: "Horse", id: "129" },
  { category: "Boat", id: "130" },
  { category: "Fish", id: "63" },
  { category: "Swim", id: "131" },
  { category: "Surf", id: "5" },
  { category: "Kayak", id: "126" },
  { category: "Canoe", id: "165" },
  { category: "Raft", id: "166" },
  { category: "Rock", id: "127" },
  { category: "Biking", id: "128" },
  { category: "Cycling", id: "128" },
  { category: "Camp", id: "79" },
  { category: "Farm", id: "134" },
  { category: "Factory", id: "135" },
  { category: "School", id: "111" },
  { category: "Library", id: "88" },
  { category: "Restaurant", id: "29" },
  { category: "Bar", id: "55" },
  { category: "Coffee", id: "83" },
  { category: "Coffee", id: "83" },
  { category: "Music", id: "67" },
  { category: "Cinema", id: "60" },
  { category: "Science", id: "22" },
  { category: "Children", id: "22" },
  { category: "Village", id: "59" },
  { category: "Villa", id: "27" },
  { category: "Mountain", id: "92" },
  { category: "City", id: "9" },
  { category: "Town", id: "59" },
  { category: "Spa", id: "163" },
  { category: "Food", id: "162" },
  { category: "Culinary", id: "161" },
  { category: "Bank", id: "4" },
  { category: "Cemetery", id: "7" },
  { category: "Hotel", id: "16" },
  { category: "Leisure", id: "19" },
  { category: "Market", id: "20" },
  { category: "Neighborhood", id: "24" },
  { category: "Street", id: "45" },
  { category: "Landmark", id: "106" },
  { category: "Religious", id: "109" },
  { category: "Nature", id: "150" },
  { category: "Festival", id: "149" },
  { category: "Fair", id: "140" },
  { category: "Lake", id: "78" },
  { category: "Stadium", id: "125" },
  { category: "Ancient", id: "69" },
  { category: "Ruin", id: "69" },
  { category: "Landscape", id: "157" },
  { category: "Night", id: "25" },
  { category: "Road", id: "96" },
  //{ category: "Military Bases", id: "" },
];
export const DISTANCES = [
  0, 0.1, 0.2, 0.3, 0.4, 0.5, 0.6, 0.7, 0.8, 0.9, 1, 2, 3, 4, 5, 10, 20, 30, 40, 50, 100, 200, 300, 400, 500, 1000,
  2000, 5000, 10000,
];

function range(start, stop) {
  var result = [];
  for (var idx = start.charCodeAt(0), end = stop.charCodeAt(0); idx <= end; ++idx) {
    result.push(String.fromCharCode(idx));
  }
  return result;
}
export var SortByEnum = { NAME: 0, CATEGORY: 1, GROUP: 2, RATING: 3, DISTANCE: 4, ZONE: 5, LEVEL: 6, DATE: 7 };
var nums = [1, 2, 3, 4, 5, 6, 7, 8, 9];
export var labelChars = nums.concat(range("A", "Z"));
export var webSite = "http://liquidguides.com/";

global.HTMLContentName = "HTMLViewer";

export function MyHashTable(obj) {
  this.length = 0;
  this.items = {};
  for (var p in obj) {
    if (obj.hasOwnProperty(p)) {
      this.items[p] = obj[p];
      this.length++;
    }
  }

  this.setItem = function (key, value) {
    var previous = "undefined";
    if (this.hasItem(key)) {
      previous = this.items[key];
    } else {
      this.length++;
    }
    this.items[key] = value;
    return previous;
  };

  this.getItem = function (key) {
    return this.hasItem(key) ? this.items[key] : "undefined";
  };

  this.hasItem = function (key) {
    return this.items.hasOwnProperty(key);
  };

  this.removeItem = function (key) {
    if (this.hasItem(key)) {
      let previous = this.items[key];
      this.length--;
      delete this.items[key];
      return previous;
    } else {
      return "undefined";
    }
  };

  this.keys = function () {
    var keys = [];
    for (var k in this.items) {
      if (this.hasItem(k)) {
        keys.push(k);
      }
    }
    return keys;
  };

  this.values = function () {
    var values = [];
    for (var k in this.items) {
      if (this.hasItem(k)) {
        values.push(this.items[k]);
      }
    }
    return values;
  };

  this.each = function (fn) {
    for (var k in this.items) {
      if (this.hasItem(k)) {
        fn(k, this.items[k]);
      }
    }
  };

  this.clear = function () {
    this.items = {};
    this.length = 0;
  };
}
// function mapStateToProps(state) {
//   return {
//     Guide: state.theGuideReducer.Guide,
//     user_info: state.theGuideReducer.user_info,
//   };
// }
// function mapDispatchToProps(dispatch) {
//   return {};
// }
// export default connect(mapStateToProps, mapDispatchToProps)(Common);

export function isSearchResult(source) {
  var Place_Source = {
    GUIDE: 0,
    USER: 1,
    SEARCH: 2,
    ATTRACTION: 3,
    WIKIPEDIA: 4,
    YOUTUBE: 5,
    PANORAMIO: 6,
    OPENTRIPMAP: 7,
    GOOGLEPLACES: 8,
    FLICKR: 9,
    PHOTO_SEARCH: 10,
    FEATURED: 11,
  };
  if (source != null)
    return (
      source === Place_Source.OPENTRIPMAP ||
      source === Place_Source.GOOGLEPLACES ||
      source === Place_Source.FLICKR ||
      source === Place_Source.WIKIPEDIA ||
      source === Place_Source.ATTRACTION ||
      source === Place_Source.PHOTO_SEARCH ||
      source === Place_Source.FEATURED
    );
}

// Every travel_questionsGPT*.php caller (TripAI.js/AISearch.js/AiDialog.js,
// both platforms) shares the same response shape and the same handful of
// real-world failure causes — out of credits, rate-limited, prompt too
// large for the model's context window — but used to show the raw
// technical label of whichever check failed ("choices", "message content",
// etc.) with no indication of WHY. Found 2026-10-04 via an "iOS-only"
// Build Trip with AI report that turned out to be the OpenAI account simply
// out of credits — the generic label gave no way to tell that apart from a
// real bug without a repro + code dive. Centralizing the interpretation
// here means every call site explains itself instead.
//
// A response that parses as valid JSON but fails one of these checks
// means the HTTP call itself succeeded — a real network/timeout failure
// throws and is caught separately, before this function is ever called.
// That leaves exactly one real shape for "valid JSON, not what we
// expected": an upstream OpenAI error response, `{"error": {"message",
// "type", "code"}}`.
export function describeAIResponseError(response) {
  const apiError = response?.error;
  if (apiError) {
    const code = apiError.code || apiError.type || "";
    if (code === "insufficient_quota" || code === "billing_hard_limit_reached") {
      return "The AI service is out of credits — check the OpenAI billing dashboard. This can't be fixed from inside the app.";
    }
    // Our own daily allowance (_gate.php), not OpenAI's — see GateLimit.js.
    if (code === "daily_limit_reached") return LIMIT_MESSAGES.ai.body;
    if (code === "rate_limit_exceeded") {
      return "The AI service is rate-limited right now — wait a moment and try again.";
    }
    if (code === "context_length_exceeded") {
      return "That request was too large for the AI to handle — try fewer destinations or a shorter trip.";
    }
    return apiError.message || `AI service error (${code || "unknown"}).`;
  }
  return "The AI didn't return a usable answer — please try again, or contact support if this keeps happening.";
}
